import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {AsyncTypeahead} from 'react-bootstrap-typeahead';
import {spinner11} from 'react-icons-kit/icomoon/spinner11';
import SvgIcon from 'react-icons-kit';
import MaskedFormControl from 'react-bootstrap-maskedinput';
//import Notifications, {notify} from 'react-notify-toast';
import moment from 'moment';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import {Table, Accordeon} from 'react-bootstrap';
import {Typeahead} from 'react-bootstrap-typeahead';
import Inputmask from 'inputmask';
import {pencilSquareO} from 'react-icons-kit/fa/pencilSquareO';
import ModalNotes from './modalNotes';
import Parser from 'html-react-parser';
import {bin} from 'react-icons-kit/icomoon/bin';
import {clipboard} from 'react-icons-kit/icomoon/clipboard';
import ModalSamples from '../modalSamples';
import {user} from 'react-icons-kit/icomoon/user';
import ModalFamiliar from '../modalFamiliar';
import {minusSquareO} from 'react-icons-kit/fa/minusSquareO';
import {search} from 'react-icons-kit/icomoon/search';
import ModalPersonSearch from '../../../generics/modal_person_search';
import ModalInfo from '../modalInfo';
import { print } from 'react-icons-kit/fa/print';
import ModalCenter from '../../../generics/modalCenter';
import {heartbeat} from 'react-icons-kit/fa/heartbeat'
import ModalConditions from './modalConditions';
import ModalDetailsApheresis from './detailsApheresis';
import {notepad_add} from 'react-icons-kit/ikons/notepad_add'
import { upload2 } from 'react-icons-kit/icomoon/upload2';
import RaisedButton from 'material-ui/RaisedButton';
import SearchImss from '../../../offers/components/SearchImss';
import SearchSearchIsste from '../../../offers/components/SearchIssste';
import Address from './Address';
import Phone from '../../../offers/components/register/Phone';

//import 'chosen-js/chosen.css';
//import chosen from 'chosen-js/chosen.jquery';

//const $ = require('jquery');
const {htmlToText} = require('html-to-text');
var Config = require('../../../../config');
const $ = require('jquery');

class PetitionForm extends Component{
	constructor(props){
		super(props);

		this.getCriterial  	= this.getCriterial.bind(this);
		this.getDocuments 	= this.getDocuments.bind(this);
		this.calcularEdad 	= this.calcularEdad.bind(this);
		this.getInfo 		= this.getInfo.bind(this);
		this.handleChange 	= this.handleChange.bind(this);
		this.clearValues 	= this.clearValues.bind(this);
		this.getServices 	= this.getServices.bind(this);
		this.getTimeServer  = this.getTimeServer.bind(this);
		this.getHourFormat  = this.getHourFormat.bind(this);
		this.getPlasmaticProduct = this.getPlasmaticProduct.bind(this);

		this.getDataPatient = this.getDataPatient.bind(this);
		this.getDataForm 	= this.getDataForm.bind(this);
		this.addComponent 	= this.addComponent.bind(this);
		this.addPlasmatic 	= this.addPlasmatic.bind(this);
		this.onChangeTest 	= this.onChangeTest.bind(this);
		this.addTestProfile = this.addTestProfile.bind(this);
		this.checked 		= this.checked.bind(this);
		this.newPatient 	= this.newPatient.bind(this);
		this.addNotes 		= this.addNotes.bind(this);

		this.getPetitionType = this.getPetitionType.bind(this);

		this.specialFields = this.specialFields.bind(this);
		this.getAnswers = this.getAnswers.bind(this);
		this.getAnswersApheresis = this.getAnswersApheresis.bind(this);
		this.setAnswers = this.setAnswers.bind(this);
		this.removeFromList = this.removeFromList.bind(this);
		this.newSample = this.newSample.bind(this);
		this.getList = this.getList.bind(this);
		this.openFamiliar = this.openFamiliar.bind(this);
		this.setFamiliar = this.setFamiliar.bind(this);
		this.samples = this.samples.bind(this);
		this.person_search = this.person_search.bind(this);
		this.getFormulario = this.getFormulario.bind(this);
		this.printConcent = this.printConcent.bind(this);
		this.printCard = this.printCard.bind(this);
		this.printLetter = this.printLetter.bind(this);
		this.getHealthFacilities = this.getHealthFacilities.bind(this);
		this.addCenter = this.addCenter.bind(this);
		this.openConditions = this.openConditions.bind(this);
		this.removePlasmatic = this.removePlasmatic.bind(this);
        this.getNextPatient = this.getNextPatient.bind(this);
        this.getFields = this.getFields.bind(this);
		this.autocompleteHandle = this.autocompleteHandle.bind(this);
		this.getAddress = this.getAddress.bind(this);

		this.state = {
            fields_patient:[],
            fields:[],
			patient_name			:"",
			statusName:false,
			patient_lastname1		:"",
			statusLastname1:false,
			patient_lastname2		:"",
			patient_rfc				:"",
			birthdate		:"",
			statusbirthdate:false,
			age				:"",
			age_type 		:"YEARS",
			lookup_group	:"",
			lookup_rh		:"",
			documents		:[],
			document_type	:"DOCUMENT_INE",
			document_number	:"",
			social_number 	:"",
			clinic_history 	:"",
			petitions		:[],
			petition 		:"",
			type_petitions  :[],
			petition_type	:"",
			loading_patient :false,
			patient_list	:[],
			patient_id		:"",
	     	person_id		:"",
			disableFields	:false,
			samples 		:[],
			clinic_history_list :[],
			plasmatic_products	:[],
			date 		  	: "",
			hour 		  	: "",
			petition_number	: "",
			petition_episodio 	 :"",
			petition_ubication	 :"",
			petition_doctor		 :"",
			petition_observations:"",
			petition_diagnosis   :"",
			reasons 			 :[],
			petition_reason 	 :"",
			plasmatic_product_id:"",
			plasmatic_product_amount:"",
			plasmaticAdded:[],
			loading_product:false,
			product_selected:[],
			index_product:-1,
			valid_prod:"",
			health_facilities     :[],
			origin_center_id:"",
			facility_sections	  :[],
			health_services	  :"",
			maternal_test_id:"",
			maternal_test_ultima_regla	 	:"",
			maternal_test_gestational_week 	:"",
			maternal_test_gestational_day	:"",
			maternal_test_expected_birthday	:"",
			maternal_test_no_fetus		 	:"",
			maternal_test_profilaxis 		:"",
			maternal_test_profilaxis_date	:"",
			maternal_test_child_alive		:"",
			maternal_test_child_dead		:"",
			maternal_test_abortions		 	:"",
			petition_components:[],
			solicited_date: "",
			solicited_hour: "",
			previous_transfutions:[],
			previous_transfutions_name:"",
			petition_previal_transfution:"",

			petition_consentimiento:"",
			petition_component_priority:"",
			petition_component_surgery_type:"",

			analitical_profiles:[],
			analitical_profile_person_id:[],
			petition_study_id:"",
			petition_study1:"",

			petition_aferesis:[],
			process_type:"", 
			process_type_id:"",
			solicitud_type:"",

			blood_components:[],
			blood_component_type:"",
			blood_component_amount:"",
			componentsAdded:[],

			isLoading:false,
			analitical_list: [],
			profile_list: [],
			
			list_test:[],
			list_profile:[],
			test:"",
			profile:"",
			index_profile:"",
			view_samples:false,

			sample_id:"",
			indice:-1,
			requestedSelected:[],
			profile_selected:[],
			pat_pol_trans:"NO",

			politransfused:false,
			cant_change:false,

			last_unit_date:"",
			unit_reserved:"",
			phenotypes:"",
			special_patient:[],
			special_values:[],
			patient_sex:"",
			lectina:"",
			du:"",
			check_age:false,
			flag_samples:"",

			doctor_lastname1:"",
			doctor_lastname2:"",
			cedula_doctor:"",
			petition_status:"",

			pat_diag_type:{},
			list_diagnosis:[],
			character_observa:'500',
			pet_fam_res:{},

			petition_family_responsable:{},
			work_sessions:[],
			work_sessions_id:"",
			have_samples:false,
			sample_selected_id:"",
			antibodys:"",
			list_unit_reserved:[],
			list_unit_delivered:[],
			last_date_send:"",
			petition_history:[],
			hide_patient:false,
			list_components:[],
			sol_mul_comp:{},
			pat_change_date_petition:{},
			campos:[],
			apheresis_fields_values:[],
			user_add_center:"",
			patient_number:"",
			rai:"",
			rai_date:"",
			pac_usr_npm:{},
			pat_pet_cond:{},
			show_details:false,
			flag_condition:false,
			imss_search:{},
			patient_idee:"",
			fromImss:false,

			civil_status_array:[],
	    	jobProfiles:[],
			street:"",
			postal_code:"",
			mpio:"",
			state:"",
			colonia:"",
			no_ext:"",
			civil_status:"",
			job_profile:"",
			indice_job:-1,
			jobSelected:[],
			phonesAdded:[],
			require_phone:false,
			show_phone:false,
			options_petition_component_priority:[],
			isste_search:"",
			token_issste:"",
			curp_issste:"",

		}
	}

	validInputDate(message, id){
		if(message !== ""){
			swal('Error', message, 'error');
			
			setTimeout(()=>{
				$('#'+id).val('')
					.attr('type', 'text')
					.attr('type', 'date');
			}, 4000);

			$('#'+id).addClass('error');
		}else{
			$('#'+id).removeClass('error');
		}
	}

	componentDidMount(){
		$(document).on('blur', '#date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);

			if(e.target.validationMessage !== ""){
				e.target.value = "";

				this.handleChange(e);
			}
		});

		$(document).on('blur', '#solicited_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);

			if(e.target.validationMessage !== ""){
				e.target.value = "";

				this.handleChange(e);
			}
		});

		$(document).on('blur', '#maternal_test_ultima_regla', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);

			if(e.target.validationMessage !== ""){
				e.target.value = "";

				this.handleChange(e);
			}
		});

		$(document).on('blur', '#maternal_test_expected_birthday', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);

			if(e.target.validationMessage !== ""){
				e.target.value = "";

				this.handleChange(e);
			}
		});

		$(document).on('blur', '#maternal_test_profilaxis_date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
		});

		$(document).on('blur', '.input-date', (e)=>{
			this.validInputDate(e.target.validationMessage, e.target.id);
			if(e.target.validationMessage !== ""){
				e.target.value = "";

				this.dateHandleChange(e);
			}
			
			
		});


		$(document).on('keyup', '.form-control', function(){
			if($(this).val() !== ""){
				if($(this).hasClass('error')){
					$(this).removeClass('error');
				}
			}
		});

		this.props.onRef(this);
		
        this.getTimeServer();
        
        this.getFields('PATIENT', 'fields_patient');

		this.specialFields(0, 1);

		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=TRANSFUSION_PRIORITIES&option=not_order',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      options_petition_component_priority: response
		    });
		})	
		fetch(Config.default.apiGateway.URL+'lookups?type=CIVIL_STATUS&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      civil_status_array: response
		    });
		})	

		//llamada a servicio de ocupacion
		fetch(Config.default.apiGateway.URL+'lookups?type=profession&option=actives&order=false',{ 
		    method: 'get',
		    headers: new Headers({
		       	'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       	'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
		  	this.setState({
		      jobProfiles: response
		    });

		})	

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=IMSS_SEARCH', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					imss_search: response
				});
			}
		});

		fetch(Config.default.apiGateway.URL+'work_sessions/'+sessionStorage.getItem("health_facilities_id"),{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(res => {
	        if(res.ok){
	          return res.json();
	        }else{
	          res.text().then(function(result) {
	            swal('¡Error', result, 'error');
	          });
        }})
		.then(response => {
			this.setState({
		      work_sessions: response
		    });
		})

		//Consultar el turno correspondiente y mostrarlo
		if(this.props.match.params.id === undefined){

			fetch(Config.default.apiGateway.URL+'work_sessions/?option=&health_facilities_id='+sessionStorage.getItem("health_facilities_id"),{ 
			    method: 'get',
			    headers: new Headers({
			       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			       'Accept': 'application/json',
			        'Content-Type': 'application/json',
			    })
			})
			.then(response => response.json())
			.then(response => {
				if(response !== null){
					this.setState({work_sessions_id:response.id});
				}else{
					swal('¡Atención!', "No existen sesiones de trabajo configuradas para su hospital", 'warning');
				}
			})
		}
			

		fetch(Config.default.apiGateway.URL+'lookups/order_by?type=petition_group_types&option=name', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({type_petitions:response});
			}
		});

		this.getHealthFacilities();

		fetch(Config.default.apiGateway.URL+'lookups?type=PROCESS_TYPE_PATIENTS&option=actives&order=false', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({petition_aferesis:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=PATIENTS_REASONS&option=actives&order=false', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({reasons:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'analytic_profile_person?option=patients', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({analitical_profiles:response});
			}
		});

		fetch(Config.default.apiGateway.URL+'lookups?type=blood_component_type&option=actives&order=false', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					blood_components: response
				});
			}
		});

		//Aqui va mi fecth para functional_criterion IISTE

		

		this.getCriterial();
		this.getDocuments();

		this.getServices();

	}

	getNextPatient(){
		fetch(Config.default.apiGateway.URL+'patients/next_patient_number', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({patient_number: response})
			}
		})
	}

	getHealthFacilities(){
		fetch(Config.default.apiGateway.URL+'national_centers?option=origin_patients&health_facility='+sessionStorage.getItem('health_facilities_id'), {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({health_facilities:response});
			}
		});
	}

	specialFields(donor, patient){
  		
  		fetch(Config.default.apiGateway.URL+'Campos/special?health_facilities_id='+
  			sessionStorage.getItem('health_facilities_id')+'&for_donors='+donor+'&for_patients='+patient,{
  			method:'get',
  			headers: new Headers({
  				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
  				'Accept'		: 'application/json',
  				'Content-Type'	: 'application/json'
  			})
  		}).then(res => {
  			if(res.ok){
  				return res.json();
  			}else{
  				res.text().then((msg)=>{
  					swal('Error', msg, 'error');
  				});
  			}
  		}).then(response => {
  			if(response !== undefined){
  				if(patient === 1){
  					this.setState({
  						special_patient: response
  					});
  				}else{
  					this.setState({
  						special_donor: response
  					});
  				}
  			}
  		});
  	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	componentDidUpdate(){
		if(this.state.petition_type !== ""){			
			var selector = document.getElementById('solicited_hour');
			var im = new Inputmask("--:--");
			//if(this.state.petition_type === 'PETICIÓN COMPONENTES'){
				if(selector !== null){
					im.mask(selector);
				}
				
			//}
		}		
	}

	getTimeServer(){
		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split('/').reverse().join('-')
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				date:date,
				hour:hours,
			});

		})
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}

	handleChange(e){
		if(e.target.value.length <= 500 && e.target.name === 'petition_observations'){
			this.setState({
				[e.target.name]: e.target.value
			});
		}/*else if(e.target.name !== 'petition_observations'){
			this.setState({
				[e.target.name]: e.target.value
			});
		}*/
		
		switch(e.target.name){
			case 'check_age':
				this.setState({
					[e.target.name]: e.target.checked
				})
				break;
			case 'hour':
			case 'solicited_hour':
				var hour = moment(e.target.value, 'h:mm a');
				this.setState({
					[e.target.name]: e.target.value
				});

				if(hour.format('H:mm') === "Invalid date" || e.target.value.indexOf('-') !== -1){
					document.getElementById(e.target.id).classList.add("error");
					document.getElementById(e.target.name).style.borderColor = "red";
				}else{
					document.getElementById(e.target.name).style.borderColor = "#ccc";
					document.getElementById(e.target.id).classList.remove("error");
				}
				break;
			
			case 'maternal_test_profilaxis':
				this.setState({
					[e.target.name]: e.target.checked
				});
				if(e.target.value === '' || e.target.value === 'NO'){
					this.setState({
						maternal_test_profilaxis_date: ""
					});
					
				}
					
				break;
			
			case 'politransfused':
				if(e.target.checked){
					this.setState({politransfused: true});
				}else{
					this.setState({politransfused: false});
				}
				break;
			
			case 'petition_previal_transfution':
				this.setState({
					petition_previal_transfution: e.target.value //e.target.checked ? 'SI' : 'NO'
				});
				break;
			
			case 'petition_consentimiento':
				this.setState({
					petition_consentimiento: e.target.checked ? 'SI' : 'NO'
				});
				break;
			
			case 'blockFields':
				if(e.target.checked){
					this.setState({disableFields:false});
					this.state.special_values.map((s)=>{
						document.getElementById(s.campos_id).disabled = false;
					})
				}else{
					this.setState({disableFields:true});
					this.state.special_values.map((s)=>{
						document.getElementById(s.campos_id).disabled = true;
					})
				}

				this.forceUpdate();
				break;
			
			case 'petition':
                this.setState({petition:e.target.value});
                this.getFields(e.target.value, 'fields');
				this.getPetition(e.target.value); 
				this.clearValues();

				if(this._typeahead_test !== undefined && this._typeahead_test !== null){
					if(this._typeahead_test.getInstance() !== null){
						this._typeahead_test.getInstance().clear();
					}
				}
				if(this._typeahead_profile !== undefined && this._typeahead_profile !== null){
					if(this._typeahead_profile.getInstance() !== null){
						this._typeahead_profile.getInstance().clear();
					}
				}
				
				this.getPetitionType(e.target.value);
				if(e.target.value === 'LABORATORY'){
					this.getAnaliticalTest();
					this.getAnaliticalProfile();

				}else if(e.target.value === 'PLASMATIC_PRODUCTS'){

					this.getPlasmaticProduct();
					this.setState({solicitud_type:''});
					
				}

				const inputs = document.querySelectorAll('select,input,textarea');
				inputs.forEach(input => {
					var control = document.getElementById(input.id);
					if(control !== null){
						if(control.className.includes('error')){
							control.classList.remove('error');
						}
					}
					
				});
				break;
			
			case 'petition_type':
				var value = e.target.value;
				this.setState({
					analitical_list: [],
					profile_list:[],
					test:"",
					profile:"",
					list_test:[],
					list_profile:[],
					solicitud_type:'PERFIL',
					index_profile: -1, 
					profile_selected: [],
					analitical_profile_person_id: [],
					list_test: [],
					test:"",
					petition_type:value
				});

				if(this.state.petition === 'LABORATORY'){
					this.getAnaliticalTest();
					this.getAnaliticalProfile();
					setTimeout(()=>{
						if(this._typeahead_test !== undefined && this._typeahead_test !== null){
							if(this._typeahead_test.getInstance() !== null){
								this._typeahead_test.getInstance().clear();
							}
						}

						if(this._typeahead_profile !== undefined && this._typeahead_profile !== null){
							if(this._typeahead_profile.getInstance() !== null){
								this._typeahead_profile.getInstance().clear();
							}
						}

						var index = this.state.petitions.findIndex(obj => obj.name === value);

						if(index !== -1){
							var profile = this.state.petitions[index].analytic_profile_person_id;
							var change = this.state.petitions[index].change_profile;
							var index_profile = this.state.profile_list.findIndex(obj => obj.profile.id === profile);

							if(!change){
								this.setState({cant_change:true});
							}else{
								this.setState({cant_change:false});
							}

							if(index_profile !== -1){
								this.setState({solicitud_type:'PERFIL'});
								setTimeout(()=>{
									this.setState({
										index_profile: index_profile, 
										profile_selected: [this.state.profile_list[index_profile]],
										analitical_profile_person_id: [...this.state.analitical_profile_person_id, profile],
									});
								
									var selected = [this.state.profile_list[index_profile]];
									
									if(selected.length > 0){
										var list = this.state.list_test;
										selected[0].analytical_test_has_analytic_profile_donors.map((test)=>{
											var index = list.findIndex(obj => obj.id === test.id);

											if(index === -1){
												list.push({
													id: test.id,
													name: test.name,
													check: true
												})
											}								
											
										})

										this.setState({
											list_test: list,
											test:""
										});
									}
									

								}, 500);
							}
						}
					}, 500);

				}
				if(this.state.petition === 'APHERESIS'){
					var index = this.state.petitions.findIndex(obj => obj.name === value);

					if(index !== -1){
						this.getFormulario(this.state.petitions[index].id);
					}
				}
				
				
				break;

			case 'solicitud_type':
				this.setState({
					[e.target.name]: e.target.value,
					analitical_list: [],
					profile_list:[],
					test:"",
					profile:"",
					//list_test:[],
					list_profile:[]
				});
				this.getAnaliticalTest();
				this.getAnaliticalProfile();
				break;

			case 'petition_observations':
				var total = 500 - e.target.value.length;
				if(e.target.value.length <= 500){
					this.setState({character_observa:total});
				}
				break;

			case 'age':
				var value = e.target.value;

				if(value !== ""){
					if(parseInt(value) >= 0 && parseInt(value) <= 109){
						this.setState({age:value})
					}
				}else{
					this.setState({age:value});
				}
				break;
			
			case 'patient_name':
			case 'patient_lastname1':
			case 'patient_lastname2':
				if(e.target.value === ""){
					this.setState({
				      [e.target.name]: e.target.value
				    });		
				}
				
				if(RegExp(/^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ´¨\/\*\-\s]+$/).test(e.target.value)){
					this.setState({[e.target.name]: e.target.value})
				}
				
				break;
			case 'clinic_history':
				if(e.target.value === ""){
					this.setState({
				      [e.target.name]: e.target.value
				    });			
				}else{
					if(e.target.value.length <= 30){
						if(RegExp("^[a-zA-ZñÑ0-9 /()\-]+$").test(e.target.value)){
							this.setState({[e.target.name]: e.target.value})
						}
					}
				}
				break;

			default:
				this.setState({
					[e.target.name]: e.target.value
				});
				break;
		}

		if(this.state.facility_sections.length === 0)
			this.getServices();
		if(e.target.value !== "" && e.target.required){
			document.getElementById(e.target.id).classList.remove("error");
		}
    }
    
    getFields(key, val){
        this.props.waiting.handleShow('Cargando...');
        fetch(Config.default.apiGateway.URL+'field_settings?form_key=PETITIONS&section_key='+key,{
			method: 'get',
		    headers: new Headers({
		       'Authorization'	: 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept'			: 'application/json',
		       'Content-Type'	: 'application/json',
		    })
		}).then(res => {
            this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				//console.log(response);
                this.setState({
                    [val]: response
                });

				var index = response.findIndex(obj => 
					obj.key === 'PATIENT_PHONE' && obj.required
				);

				if(index !== -1){
					this.setState({require_phone:true});
				}

				index = response.findIndex(obj => 
					obj.key === 'PATIENT_PHONE' && obj.print
				);

				if(index !== -1){
					this.setState({show_phone:true});
				}
			}
        });
    }

	getPetitionType(key){
		fetch(Config.default.apiGateway.URL+'petition_type/by_group_type?type='+key, {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({
      				petitions:response
      			});
      			if(this.props.match.params.id === undefined){
      				this.setState({
	      				petition_type: key === 'LABORATORY' || key === 'APHERESIS' ? "": response.length > 0 ? response[0].name : ''
					});
      			}else{
					if(key === 'APHERESIS'){
						var index = response.findIndex(obj => obj.name === this.state.petition_type);

						if(index !== -1){
							this.getFormulario(response[index].id);
						}
					}else if( key === 'LABORATORY'){
						if(this.state.petition_type !== ""){
							var index = response.findIndex(obj => obj.name === this.state.petition_type);

							if(index !== -1){
								this.setState({
									petition_type: response[index].name
								});
							}
							
						}
						
					
					}else{
						this.setState({
							petition_type: response.length > 0 ? response[0].name : ''
					  	});
						
					}
				}
      		}
      	});
	}

	getFormulario(id){
		fetch(Config.default.apiGateway.URL+'apheresis_fields/by_petition_type?petition_type_id='+id+'&sex='+this.state.patient_sex,{
			method:'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json' 
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({campos: response});

				setTimeout(()=>{
					if(this.state.apheresis_fields_values.length > 0){
						this.state.apheresis_fields_values.map((a)=>
							document.getElementById(a.apheresis_field_id).value = a.value
						);
					}
				}, 500)
			}
		})
	}

	getCriterial(){
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_PET_COND', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pat_pet_cond:response.value});      					
      		}
		});
		
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=USER_ADD_CENTER', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({user_add_center:response.value});      					
      		}
		  });

		  fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAC_USR_NPM', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pac_usr_npm:response.value});      	

      			
      			if(response.value === 'YES'){
					this.setState({patient_number:""});
				}else{
					this.getNextPatient();
				}				
      		}
		  });
		  
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_POL_TRANS', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pat_pol_trans:response.value});      					
      		}
      	});

      	fetch(Config.default.apiGateway.URL+'functional_criterion?code=PET_FAM_RES', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pet_fam_res:response});      					
      		}
      	});

      	//Criterio funcional,cambiar lugar de colecta
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_DIAG_TYPE',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				pat_diag_type: response
			});

			if(response.value !== 'OPEN'){
				this.getDiagnosis();
			}
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=SOL_MUL_COMP',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				sol_mul_comp: response
			});
		})

		fetch(Config.default.apiGateway.URL+'functional_criterion?code=PAT_CHANG_DATE_PETITION', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({pat_change_date_petition:response});      					
      		}
      	});

		//Criterio funcional, ISSTE_SEARCH
		fetch(Config.default.apiGateway.URL+'functional_criterion?code=ISSSTE_SEARCH', {
			method: 'get',
			headers: new Headers({
			   'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
			   'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		}).then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
          	}
      	}).then(response => {
      		if(response !== undefined){
      			this.setState({isste_search:response.value});
				this.getTokenIssste();      					
      		}
      	});
	}
	getTokenIssste(){
		if (this.state.isste_search === "YES") {
			//console.log("Obteniendo token ISSSTE...");

			fetch(Config.default.apiGateway.URL+'functional_criterion?code=ISSSTE_TOKEN', {
				method: 'get',
				headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
					'Content-Type': 'application/json',
				})
			}).then(res => {
				if(res.ok){
				return res.json();
				}else{
				res.text().then(function(result) {
					swal('¡Error','Error al obtener el token: ' + result, 'error');
				});
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({token_issste:response.value});
					localStorage.setItem("issste_token", response.value);
					//console.log("Token ISSSTE obtenido: " + response.value);					
				}
			});
		}
	}
	getDiagnosis(){
		fetch(Config.default.apiGateway.URL+'diagnostics',{ 
			method: 'get',
			headers: new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			})
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
				list_diagnosis: response
			});

			
		})
	}

	getDocuments(){
		fetch(Config.default.apiGateway.URL+'lookups?type=document_type&notrender=0',{
			method: 'get',
			headers: new Headers({
			   	'Authorization' : 'Bearer ' + sessionStorage.getItem("token") , 
			   	'Accept' 		: 'application/json',
				'Content-Type' 	: 'application/json',
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response=>{
			if(response !== undefined){
				this.setState({documents:response});
			}
		})
	}

	//busqueda paciente
	handleSearch = (query) => {
	    this.setState({loading_patient: true});
	    
		fetch(Config.default.apiGateway.URL+'person?search='+query,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
			}),
			cache:'no-cache'
		})
		.then(response => response.json())
		.then(response => {
			if(response !== null){
				for (var i = 0; i < response.length; i++) {
					
					/* revisar en la base de datos el lastname1 y lastname2 ya que lastname1 contiene el lastname2*/

					if(response[i].lastname2 !== undefined && response[i].lastname2 !== null && response[i].lastname2 !== ""){
						response[i].names = response[i].lastname1 +' '+ response[i].lastname2+' '
											+response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					
					}else{
						response[i].names = response[i].lastname1 +' '+ response[i].names +' '+ 
											(response[i].birthday !== null ? response[i].birthday : '');
					}


					if(response[i].document_type_value !== null){
						response[i].names +=' '+response[i].document_type_value;
					}

					if(response[i].document_number !== null){
						response[i].names +=' '+response[i].document_number;
					}

					if(response[i].number !== null){
						response[i].names += ' '+response[i].number
					}

					if(response[i].social_number !== null){
						response[i].names += ' '+response[i].social_number
					}
					
					response[i].id = response[i].patient_id;
				};
				

				//error
				this.setState({
					loading_patient: false,
			     	patient_list: response,
			     	/*patient_id: "",
			     	person_id: "",
					names: "",
					lastname1: "",
					lastname2: "",
					clinic_history: "",
					disableFields: false,*/
			    });
				
			    setTimeout(()=>{
			    	if(this.modal_person_search.state.show){
			    		var id = '';
			    		this.modal_person_search.state.list.map((p)=>{
			    			if(p.check){
			    				id = p.person_id;
			    			}
			    		});

			    		var index = this.state.patient_list.findIndex(obj => 
			    			 parseInt(obj.person_id) === parseInt(id)
			    		);

			    		if(index !== -1){
			    			this.getInfo([this.state.patient_list[index]]);
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}else{
			    			swal('Información', 'No se encontraron resultados de este paciente', 'info')
			    			this.modal_person_search.handleClose();
			    			this.props.waiting.handleClose();
			    		}
			    	}
			    	
			    }, 500);
			}
		})
	}

	calcularEdad(fecha, control){
		var hoy = new Date();
	    var cumpleanos = new Date(fecha.split(/\//).reverse().join('/'));
	    if(cumpleanos.toString() !== 'Invalid Date'){
		    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
		    var m = hoy.getMonth() - cumpleanos.getMonth();

		    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
		        edad--;
		    }

		    
		    if(edad >= 0 && edad < 110){
		    	this.setState({age:edad});	
		    }else{
		    	this.setState({age:'', birthdate:''});	
		    	swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		    }
		    

		    
		}else{
			this.setState({age:'', birthdate:''});	
		    swal('Error', 'Fecha de nacimiento incorrecta', 'error');
		}
	}

	getInfo(e){
		var id = "";
		this.setState({
	     	patient_id: "",
	     	person_id: "",
			patient_name: "",
			patient_lastname1: "",
			patient_lastname2: "",
			clinic_history: "",
			age:"",
			age_type:"YEARS",
			patient_sex:"",
			phenotypes:"",
			antibodys:"",
			list_unit_reserved:[],
			list_unit_delivered:[],
			last_date_send:"",
			petition_history:[],
			rai:"",
			rai_date:"",
			street:"",
			postal_code:"",
			mpio:"",
			state:"",
			colonia:"",
			no_ext:"",
			civil_status:"",
			job_profile:"",
			phonesAdded:[],
	    });
	   //console.log("Estado inicial:", e[0]);
		if(e.length > 0){
			if(e[0].patient === undefined && e[0].num_issste === undefined && e[0].ito_id === undefined){
				if(e[0].id !== 0){
					fetch(Config.default.apiGateway.URL+'patients/patient_offer?id='+e[0].id,{
				   		method:'GET',
				   		headers: new Headers({
				   			'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				   			'Accept'		: 'application/json',
				   			'Content-Type'	: 'application/json'
				   		})
				   	}).then(res => {
				   		if(res.ok){
				   			return res.json();
				   		}else{
				   			res.text().then((msg)=>{
				   				swal('Error', msg, 'error');
				   			});
				   		}
				   	}).then(response => {
				   		if(response !== undefined){
							this.getInfo([response]);
			    			return;
				   		}
				   	})
			  	}else{
			  		var value = e[0];
			  		var item = {
						person:{
							birthday:value.FECHA_NACIMIENTO.DateTime,
							names: value.NOMBRE,
							lastname1: value.PRIMER_APELLIDO,
							lastname2: value.SEGUNDO_APELLIDO,
							id: value.patient_id,
							social_number: value.NSS,
							sex: value.SEXO === 'F' ? 'MUJER' : value.SEXO === 'M' ? 'HOMBRE' : '',
							national_center_id:"",
							idee: value.IDEE,
							lookup_group:"",
							lookup_rh:""

						},
						patient:{
							id: value.patient_id,
							patient_number: "",
							observations:"",
							number:""
						}
					};

					this.setState({
						fromImss:true,
						street:value.CALLE,
						colonia:value.COLONIA
					});

					this.getInfo([item]);
			  	}
			}

			
			if(e[0].patient !== undefined && e[0].num_issste === undefined){
				id = e[0].id !== undefined ? e[0].id : e[0].patient.id;
				this.setState({
					patient_id: id,
					person_id:e[0].person.id,
					patient_name: e[0].person.names,
					patient_lastname1: e[0].person.lastname1,
					patient_lastname2: e[0].person.lastname2,
					clinic_history: e[0].patient.number,
					social_number: e[0].person.social_number,
					patient_idee: e[0].person.idee,
					disableFields: true,
					
					birthdate: e[0].person.birthday !== null ? moment(e[0].person.birthday).format('DD/MM/YYYY') : '',
					lookup_group: e[0].person.lookup_group,
					lookup_rh: e[0].person.lookup_rh,
					loading_patient:false,
					samples: e[0].all_samples !== undefined ? e[0].all_samples : [],
					patient_sex:e[0].person.sex,
					rai:e[0].rai,
					rai_date:moment(e[0].rai_date).format('DD/MM/YYYY HH:mm')
				});

				if(id !== 0){
					this.infoPatient(id);	
				}				

				if(this.state.pat_pol_trans === 'YES'){
					this.setState({
						politransfused: e[0].patient.politransfused !== null ? e[0].patient.politransfused : false
					});
					
				}

				if(e[0].person.birthday !== null){
					var control = document.getElementById('birthdate');
				
					this.calcularEdad(e[0].person.birthday, control);
				}

				this._typeahead.getInstance().clear();

				if(id !== 0){
					fetch(Config.default.apiGateway.URL+'samples/by_patient?patient_id='+id, {
						method: 'get',
						headers: new Headers({
							'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					}).then(res => {
						this.props.waiting.handleClose();
						if(res.ok){
							return res.json();
						}else{
							res.text().then((msg)=>{
								swal('Error', msg, 'error');	
							});
							
						}
					}).then(response => {
						if(response !== undefined){
							if(response.length > 0){
								this.setState({have_samples:true});
							}
						}
					});		
				}

				setTimeout(()=>{
					this.setState({
						clinic_history_list:[],
						patient_list: [],
					});
				}, 500);
			} 
			if (e[0].num_issste !== undefined){
				//swal('Información', 'El paciente pertenece al ISSSTE, favor de buscar en el módulo de ISSSTE'+ e[0].nom_tra, 'info');
			    this.setState({
					patient_name: e[0].nom_tra,
					patient_lastname1: e[0].apa_tra,
					patient_lastname2: e[0].ama_tra,
					patient_idee: e[0].num_issste,
					patient_rfc: e[0].rfc_tra,
					patient_sex:e[0].sexo,
					document_type:"DOCUMENT_CURP",
					curp_issste:e[0].curp_tra,

				});  

			}
			if(e[0].ito_id !== undefined){
				this.setState({
					patient_name: e[0].nombre,
					patient_lastname1: e[0].apellido_paterno,
					patient_lastname2: e[0].apellido_materno,
					patient_idee: e[0].ito_id,
					patient_rfc: e[0].rfc_tra,
					loading_patient:false,
					patient_sex:e[0].sexo,
					document_type:"DOCUMENT_CURP",
					curp_issste:e[0].curp,
					rai_date:moment(e[0].rai_date).format('DD/MM/YYYY HH:mm')
				});
			}
		}
	}

	infoPatient(id){
		fetch(Config.default.apiGateway.URL+'patients/'+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					document_type: response.document !== undefined && response.document !== null ? 
									response.document.document_type : "",
					document_number: response.document !== undefined && response.document !== null ? 
									response.document.document_number : "" ,
					last_unit_date:response.last_unit_delivered,
					unit_reserved:response.unit_reserved,
					list_unit_reserved:response.list_units_reserved,
					list_unit_delivered:response.list_units_delivered,
					last_date_send:response.last_unit_delivered,
					petition_history:response.petitions,
					
				});

				if( response.patient.patient_number !== null ){
					this.setState({patient_number: response.patient.patient_number});
				}

				var phen = '';
				response.phenotype.map((p, i)=>{
					phen += p.phenotype1+p.result+( i === response.phenotype.length -1 ? '' : ', ')
				})

				var anti = "";
				response.antibodys.map((a, i)=>{
					if(a.result === '1'){
						anti += a.antibody+( i === response.antibodys.length -1 ? '' : ', ')
					}	
				})

				if(response.test_result !== null){
					if(response.test_result.length > 0){
						response.test_result.map((t)=>{
							if(t.name === 'GRUPO'){
								this.setState({lookup_group:t.value});
							}

							if(t.name === 'RH'){
								this.setState({lookup_rh:t.value});
							}

							if(t.name === 'LECTINA'){
								this.setState({lectina:t.value});
							}

							if(t.name === 'DU'){
								this.setState({du:t.value});
							}
						})
					}
						
				}

				this.setState({phenotypes: phen, antibodys:anti});

				if(response.alerts !== undefined){
					if(response.alerts.length > 0){
						var alerts = "";
						response.alerts.map((n)=>{
							var note = htmlToText(n);
							alerts += note;
						})

						swal('Alerta', alerts, 'warning')
					}
				}

				if(response.flag_conditions === true){
					swal('Alerta', "El paciente tiene condiciones de reserva y envío", 'warning');
				}
			}
		});
	}

	newPatient(){
		this._typeahead.getInstance().clear();
		this.setState({
			loading_patient: false,
	     	patient_list: [],
	     	patient_id: "",
	     	person_id: "",
		    patient_idee:"",
			patient_name: "",
			patient_lastname1: "",
			patient_lastname2: "",
			clinic_history: "",
			document_type:"",
			document_number:"",
			social_number:"",
			birthdate:"",
			age:"",
			disableFields: false,
			lookup_group:"",
			lookup_rh:"",
			patient_sex:"",
			//clinic_history_s:"",
			lectina:"",
			du:"",
			age_type:"YEARS",
			check_age:false,
			sample_selected_id:"",
			rai:"",
			fromImss:false,
			street:"",
			postal_code:"",
			mpio:"",
			state:"",
			colonia:"",
			no_ext:"",
			civil_status:"",
			job_profile:"",
			phonesAdded:[],
			curp_issste:""
	    });

	    this.clearAnswers();
	}

	getPetition(petition){
		this.setState({petition_type:petition});

		this.setState({
			petition_episodio 	 :"",
			petition_location	 :"",
			petition_doctor		 :"",
			petition_observations:"",
			petition_diagnosis   :"",
			petition_reason 	 :"",
			products: [],
			plasmatic_product_id:"",
			health_facilities_name:"",
			health_services	  :"",
			maternal_test_ultima_regla	 	:"",
			maternal_test_gestational_week 	:"",
			maternal_test_gestational_day	:"",
			maternal_test_expected_birthday	:"",
			maternal_test_no_fetus		 	:"",
			maternal_test_profilaxis 		:"",
			maternal_test_profilaxis_date	:"",
			maternal_test_child_alive		:"",
			maternal_test_child_dead		:"",
			maternal_test_abortions		 	:""
		});
			

		this.removeValidation();
	}

	removeValidation(){
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		var control = document.getElementById(input.name);
	    		if(control !== null){
	    			control.classList.remove('error');
	    		}
	    		
		  	}
	    });
	}

	clearValues(){
		this.setState({
			petition_number	: "",
			petition_id: "",
			petition_episodio 	 :"",
			petition_ubication	 :"",
			petition_doctor		 :"",
			petition_observations:"",
			petition_diagnosis   :"",
			petition_reason 	 :"",

			plasmatic_products: [],
			plasmatic_product_id:"",
			plasmatic_product_amount:"",
			
			origin_center_id:"",

			health_services	  :"",
			
			maternal_test_ultima_regla	 	:"",
			maternal_test_gestational_week 	:"",
			maternal_test_gestational_day	:"",
			maternal_test_expected_birthday	:"",
			maternal_test_no_fetus		 	:"",
			maternal_test_profilaxis 		:"",
			maternal_test_profilaxis_date	:"",
			maternal_test_child_alive		:"",
			maternal_test_child_dead		:"",
			maternal_test_abortions		 	:"",

			petition_components:[],
			
			solicited_date: "",
			solicited_hour: "",

			previous_transfutions:[],
			previous_transfutions_name:"",
			petition_previal_transfution:"",

			petition_consentimiento:"",
			petition_component_priority:"",
			petition_component_surgery_type:"",

			analitical_profile_person_id:"",
			process_type:"", 
			solicitud_type:"",

			blood_component_type:"",
			blood_component_amount:"",
			componentsAdded:[],

			isLoading:false,
			analitical_list: [],
			list_test:[],
			test:"",
			profile:"",

			doctor_lastnames:"",
			cedula_doctor:"",
			petition_status:"",
			campos:[],
			flag_condition:false
			//apheresis_fields_values:[]
		})	
	}

	getPlasmaticProduct(){
		fetch(Config.default.apiGateway.URL+'plasmatic_product?option=actives', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({plasmatic_products: response});
			}
		});
	}

	handleTypeAheadChange = name => values => {
        if(values.length > 0){
        	if(name === 'product'){
        		this.setState({loading_product:true});

        		setTimeout(()=>{
        			this.setState({
						index_product:0,
						product_selected:values,
						plasmatic_product_amount:1,
						loading_product:false,
						plasmatic_product_id:values[0].id,
						valid_prod: ''
				    });

				    this._typeahead_product.getInstance().blur();
				    document.getElementById('plasmatic_product_amount').focus();

				    //this.errorAutoComplete('product');
        		}, 1000);
	        }else if(name === 'job_profile'){
				this.setState({
					isLoading:false,
					[name]: values[0].key,
		            indice_job:0,
					jobSelected:values,
				})
				
        	}else{
        		this.setState({
	    			isLoading:false,
		            [name]: values[0].id,
		            indice:0,
					requestedSelected:values,
		        });

				if(document.getElementById('origin_center_id') !== null){
					document.getElementById('origin_center_id').classList.remove('error');
				}

				if(document.getElementById('health_services') !== null){
					document.getElementById('health_services').focus();
				}
        	}
	    		        	
        }
    }

    _handleSearch2 = (query) => {
	    this.setState({
	    	isLoading:true,
			indice:-1,
			requestedSelected:[],
			origin_center_id:""
	    });



	    setTimeout(()=>{this.setState({isLoading:false})}, 10000);
	}

	getServices(){
		fetch(Config.default.apiGateway.URL+'lookups?type=health_services&option=actives&order=true', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({facility_sections:response});
			}
		});
	}

	getAnaliticalTest(){
		fetch(Config.default.apiGateway.URL+'analitical_test?option=active', {
			method: 'get',
			headers: new Headers({
				'Authorization'	: "Bearer "+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
 			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.test().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({analitical_list:response});
			}
		})
	}

	getAnaliticalProfile(){
		fetch(Config.default.apiGateway.URL+'analytic_profile_person?option=patients', {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(msg){
					swal("Error", msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({profile_list:response});
			}
		});
	}

	addComponent(){
		if(this.state.blood_component_type === "" && this.state.blood_component_amount === ""){
			document.getElementById('blood_component_type').classList.add('error');
			document.getElementById('blood_component_amount').classList.add('error');

		}else if(this.state.blood_component_amount === "" && this.state.blood_component_type !== ""){
			document.getElementById('blood_component_amount').classList.add('error');
			document.getElementById('blood_component_type').classList.remove('error');

		}else if(this.state.blood_component_amount !== "" && this.state.blood_component_type === ""){
			document.getElementById('blood_component_type').classList.add('error');
			document.getElementById('blood_component_amount').classList.remove('error');

		}else{
			document.getElementById('blood_component_type').classList.remove('error');
			document.getElementById('blood_component_amount').classList.remove('error');

			var flag = false;
			var error = '';

			this.state.petition_components.some((c, i)=>{
				if(c.component_type === this.state.blood_component_type){
					//flag = true;
					return false;
				}

			});

			
			if(this.state.sol_mul_comp.value === 'NO'){
				var index = this.state.petition_components.findIndex(obj => obj.component_type === this.state.blood_component_type)

				if(this.state.petition_components.length > 0){
					if(index !== -1){
						flag = false;
					}else{
						flag = true;
						error = 'Sólo está permitido agregar 1 tipo de componente por petición';
					}
				}
					
			}


			if(!flag){
				var petition = {
					amount: this.state.blood_component_amount,
					component_type: this.state.blood_component_type,
					surgery_type: this.state.petition_component_surgery_type,
					priority: this.state.petition_component_priority,
					solicitedfor_date: this.state.solicited_date,
					solicitedfor_hour: this.state.solicited_hour,
					previous_transfusions: this.state.petition_previal_transfution,
					informed_consent: this.state.petition_consentimiento,
					petitions_id: this.state.petition_id,
					id:""
				};
				this.setState({
					petition_components: [...this.state.petition_components, petition],
					blood_component_type: "",
					blood_component_amount:"",
				});
			}else{
				//swal('Error', 'El componente ya se encuentra en la tabla', 'error');
				swal('Error', error, 'error');
			}
			
		}
	}

	addPlasmatic(){
		var index = this.state.plasmatic_products.findIndex(obj => obj.id === parseInt(this.state.plasmatic_product_id));
		var inserted = this.state.plasmaticAdded.findIndex(obj => parseInt(obj.id) === parseInt(this.state.plasmatic_product_id));
		if(index !== -1){
			if(inserted === -1){
				
					if(this.state.plasmatic_product_amount !== ""){
						this.setState({
							plasmaticAdded: [
								...this.state.plasmaticAdded, {
									id: this.state.plasmatic_product_id,
									name: this.state.plasmatic_products[index].name,
									amount: this.state.plasmatic_product_amount
								}
							],
							plasmatic_product_id:"",
							plasmatic_product_amount:""
						});

						this._typeahead_product.getInstance().clear();
						this._typeahead_product.getInstance().focus();
					}else{
						swal('Error', 'Debe ingresar una cantidad', 'error');
					}
				
						
			}else{
				swal('Error', 'El producto ya se encuentra en la tabla', 'error');
			}
				
		}else{
			swal('Error', 'Debe seleccionar un producto', 'error');
		}		
	}

	addTestProfile(campo){
		if(this.state.test.analitical_test !== undefined){
			var index = this.state.list_test.findIndex(obj => obj.id === this.state.test.analitical_test.id);

			if(index === -1){
				this.setState({
					list_test: [
						...this.state.list_test,
						{
							id: this.state.test.analitical_test.id,
							name: this.state.test.analitical_test.name,
							check: true
						}
					],
					test:""
				});

				this._typeahead_test.getInstance().clear();

			}else{
				swal('Error', 'La prueba ya se encuentra en la tabla', 'error');
						
			}
		}else{
			swal('Error', 'Debe seleccionar una prueba', 'error');

		}
	}

	onChangeTest = tipo => e => {
		if(e.length > 0){
			if(tipo === 'profile'){
				this.setState({
					analitical_profile_person_id: [...this.state.analitical_profile_person_id, e[0].profile.id],
					//list_test:[]
				});
				setTimeout(()=>{
					if(e[0].analytical_test_has_analytic_profile_donors.length > 0){
						var list = this.state.list_test;


						e[0].analytical_test_has_analytic_profile_donors.map((test)=>{
							var index = list.findIndex(obj => obj.id === test.id);

							if(index === -1){
								list.push({
									id: test.id,
									name: test.name,
									check: true
								})
							}								
							
						})

						this.setState({
							list_test: list,
							test:""
						});
					}

					var index = this.state.profile_list.findIndex(obj => 
									obj.profile.id === e[0].profile.id
								);

					if(index !== -1){
						this.setState({
							profile_selected: [this.state.profile_list[index]]
						})
					}

				}, 500)
					
			}else{
				this.setState({
					test: e[0]
				})
				
			}
		}
	}

	checked(e){
		this.state.list_test.some((list, i)=>{
			if("test_"+list.id === e.target.id){
				list.check ? list.check= false : list.check = true
			}
			 
		})

		this.forceUpdate();
	}

	getDataForm(){
		var obj = {};
		var date = moment(this.state.date.split('-').reverse().join('/'), 'DD-MM-YYYY');
		var hour = moment(this.state.hour, 'h:mm a');

		var index = this.state.petitions.findIndex((obj => obj.name === this.state.petition_type));

		obj.petition_type_id 	 = this.state.petitions[index].id;
		obj.petition_date 	  	 = date.format('MM-DD-YYYY');
		obj.petition_hour 		 = hour.format('HH:mm');
		obj.petition_number 	 = this.state.petition_number;
		obj.patient_age          = this.state.age;
		obj.episodio 	 	     = this.state.petition_episodio;
		obj.health_services 	 = this.state.health_services;
		obj.ubication 			 = this.state.petition_ubication;
		obj.doctor 				 = this.state.petition_doctor;
		obj.observations 		 = this.state.petition_observations;
		obj.origin_center_id 	 = this.state.origin_center_id;
		obj.age_type 			 = this.state.age_type;

		obj.diagnosis 	= this.state.petition_diagnosis;
		obj.reason 		= this.state.petition_reason;
		obj.surgery_type = this.state.petition_component_surgery_type;
		obj.priority = this.state.petition_component_priority;

		var pickupdate = moment(this.state.solicited_date.split('-').reverse().join('/'), 'DD-MM-YYYY');
		obj.pickup_date = pickupdate.format('MM-DD-YYYY');

		obj.previal_transfution = this.state.petition_previal_transfution;
		obj.consentimineto_informado = this.state.petition_consentimiento;
		
		obj.work_sessions_id = this.state.work_sessions_id; 
		obj.cedula_medico = this.state.cedula_doctor;
		obj.doctor_lastname1 = this.state.doctor_lastname1;
		obj.doctor_lastname2 = this.state.doctor_lastname2;
		obj.status 			 = this.state.petition_status;
		obj.curp 	 = this.state.curp_issste;


		if(this.state.petition_id !== ""){
			obj.id = this.state.petition_id;
		}else{
			obj.id = "";
		}

		obj.diagnosis 	 = this.state.petition_diagnosis;
		if(this.state.petition === 'APHERESIS'){
			if(this.state.process_type_id !== ""){
				obj.petition_aferesis = [{
					id: this.state.process_type_id,
					petition_id: this.state.petition_id,
					process_type: this.state.process_type
				}];
			}else{
				obj.petition_aferesis = [{
					process_type: this.state.process_type
				}];
			}
		}else if(this.state.petition === 'COMPONENTS' || this.state.petition === 'URGENT_COMPONENTS'){
			obj.petitions_blood_components = this.state.petition_components;
			obj.petitions_blood_components.map((comp)=>{
				comp.informed_consent = this.state.petition_consentimiento;
				comp.previous_transfusions = this.state.petition_previal_transfution;
				comp.priority = this.state.petition_component_priority;
				comp.solicitedfor_date = this.state.solicited_date;
				comp.solicitedfor_hour = this.state.solicited_hour;
				comp.surgery_type = this.state.petition_component_surgery_type;
			});
		}else if(this.state.petition_type.indexOf('MATERNO') !== -1){
			var maternal = {
				ultima_regla: moment(this.state.maternal_test_ultima_regla).format('MM-DD-YYYY'),
				gestational_week: this.state.maternal_test_gestational_week,
				gestational_day: this.state.maternal_test_gestational_day,
				expected_birth: this.state.maternal_test_expected_birthday,
				no_fetus: this.state.maternal_test_no_fetus,
				prophylaxis: this.state.maternal_test_profilaxis === 'SI' ? true : 
							this.state.maternal_test_profilaxis === 'NO' ? false : null,
				prophylaxis_date: moment(this.state.maternal_test_profilaxis_date).format('MM-DD-YYYY'),
				child_alive: this.state.maternal_test_child_alive,
				child_dead: this.state.maternal_test_child_dead,
				abortions: this.state.maternal_test_abortions,
			}

			if(this.state.petition_id !== ""){
				maternal.petition_id = this.state.petition_id;
				maternal.id = this.state.maternal_test_id;
			}
			obj.maternal_test = [maternal];

			var solicitud = [];

			if(this.state.list_test.length > 0){

				this.state.list_test.map((list)=>{
					if(list.check){
						if(this.state.solicitud_type === "PRUEBA"){
							if(this.state.petition_id !== ""){
								obj.id = this.state.petition_id;

								solicitud.push({
									analitical_test_id: list.id,
									petition_id: list.petition_id !== undefined ? list.petition_id : this.state.petition_id
								});
							}else{
								solicitud.push({
									analitical_test_id: list.id
								});
							}
								
						}else{
							if(this.state.petition_id !== ""){
								solicitud.push({
									analytic_profile_person_id: this.state.analitical_profile_person_id,
									analitical_test_id: list.id,
									petition_id: this.state.petition_id
								});
							}else{
								solicitud.push({
									analytic_profile_person_id: this.state.analitical_profile_person_id,
									analitical_test_id: list.id
								});
							}
						}
					}
					
				});

			}else{
				solicitud = [{
					analytic_profile_person_id:this.state.analitical_profile_person_id
				}]
			}

			obj.petition_lab = solicitud;

		}else if(this.state.petition === 'PLASMATIC_PRODUCTS'){
			
			var prod = []
			this.state.plasmaticAdded.map((add, i)=>{
				if(add.id_plasmatic !== undefined && add.id_plasmatic !== ""){
					return prod.push({
						id: add.id_plasmatic,
						petition_id: this.state.petition_id,
						plasmatic_product_id: parseInt(add.id),
						amount: add.amount
					});
				}else{
					return prod.push({
						petition_id: this.state.petition_id,
						plasmatic_product_id: parseInt(add.id),
						amount: add.amount
					});
				}
				
			});

			obj.petition_products = prod;
		}else{
			solicitud = [];

			if(this.state.list_test.length > 0){

				this.state.list_test.map((list)=>{
					if(list.check){
						if(this.state.solicitud_type === "PRUEBA"){
							if(this.state.petition_id !== ""){
								obj.id = this.state.petition_id;

								solicitud.push({
									analitical_test_id: list.id,
									petition_id: list.petition_id !== undefined ? list.petition_id : this.state.petition_id
								});
							}else{
								solicitud.push({
									analitical_test_id: list.id
								});
							}
								
						}else{
							if(this.state.petition_id !== ""){
								solicitud.push({
									analytic_profile_person_id: this.state.analitical_profile_person_id[0],
									analitical_test_id: list.id,
									petition_id: this.state.petition_id
								});
							}else{
								solicitud.push({
									analytic_profile_person_id: this.state.analitical_profile_person_id[0],
									analitical_test_id: list.id
								});
							}
						}
					}
					
				});

			}else{
				solicitud = [{
					analytic_profile_person_id:this.state.analitical_profile_person_id[0]
				}]
			}

			if(this.state.petition !== 'STUDY_HLA'){
				obj.petition_lab = solicitud;
			}
		}

		return obj;
	}

	getAddress(){
		var address = {
			street:this.state.street,
			ext_num:this.state.no_ext,
			colonia:this.state.colonia,
			postal_code:this.state.postal_code,
			municipio:this.state.mpio,
			estado:this.state.state,
		};
		
		if(this.state.address_id!==""){
			address.id = this.state.address_id;
		}

		return address;
	}

	getDataPatient(){

		//Verificar que existan peticiones del tipo seleccionado
		var index = this.state.type_petitions.findIndex(obj => (obj.key === this.state.petition));
		if(this.state.petitions.length == 0){
			var name_petition_type = this.state.type_petitions[index].name;
			swal('¡Error!', 'No existen peticiones configuradas con el "Tipo de Peticion" seleccionado ("'+name_petition_type+'")', 'error');
			return null;	
		}

		var obj = {};
		var birth = moment(this.state.birthdate, 'DD-MM-YYYY');

		obj.person = {
			person_type: "PATIENT",
			social_number : this.state.social_number,
			names : this.state.patient_name.trim(),
			idee: this.state.patient_idee,
			lastname1 : this.state.patient_lastname1.trim(),
			birthday : birth.format('MM-DD-YYYY') !== 'Invalid date' ? birth.format('MM-DD-YYYY') : "",
			person_rfc:this.state.patient_rfc,
			lastname2 : this.state.patient_lastname2.trim(),	
			lookup_group: this.state.lookup_group,
			lookup_rh: this.state.lookup_rh,
			sex:this.state.patient_sex,
			civil_status:this.state.civil_status,
			job_profile:this.state.job_profile,
			phones:this.state.phonesAdded
		}

		if(this.state.document_number !== null && this.state.document_number !==undefined && this.state.document_number !== ""){
			obj.person.documents = [];
			obj.person.documents.push({document_type: this.state.document_type, document_number:this.state.document_number});
		}

		obj.number = this.state.clinic_history;
		obj.politransfused = this.state.politransfused;
	
		obj.patient_number = this.state.patient_number;
		
		if(this.state.person_id !== ""){
			obj.id = this.state.patient_id;
			obj.person.id = this.state.person_id;
		}

		var index = this.state.petitions.findIndex(obj => (obj.name === this.state.petition_type));
		obj.petition_type_id 	 = this.state.petitions[index].id;
		
		return obj;
	}

	dateHandleChange = (event) => {
		this.setState({
	      	birthdate: event.target.value
	    });
		
		var control = document.getElementById(event.target.id);
		if(event.target.value.length === 10 && event.target.value.indexOf('_') === -1){
			control.classList.remove('error');
	    	this.calcularEdad(event.target.value, control);
		}else{
			if(event.target.value === ""){
				control.classList.remove('error');
				this.setState({age: ""});
			}else{
				this.setState({age: ""});
				control.classList.add('error');
			}
		}
	}

	addNotes(e, id){
		e.preventDefault();
		this.modal_notes.handleShow(id, 'petition');
	}

	clearAnswers(){
		this.state.special_patient.map((s)=>{
			document.getElementById(s.IdCampo).value = ''
		});		
  	}

  	getAnswers(){
		var obj = {}, res =[];

		this.state.special_patient.map((s)=>{
			obj = {
				campos_id:s.IdCampo,
				valor: document.getElementById(s.IdCampo) !== null ? document.getElementById(s.IdCampo).value : ""
			}

			var index = this.state.special_values.indexOf(obj => 
				obj.campos_id === s.IdCampo
			);

			if(index !== -1){
				obj.id = this.state.special_values[index].id;
				obj.offer_id = this.state.special_values[index].offer_id;

				res.push(obj);
				
			}else{
				res.push(obj);
			}
		})
		
		return res;
	}

	setAnswers(items){
		items.map((item)=>{
			document.getElementById(item.campos_id).value = item.valor;
			document.getElementById(item.campos_id).disabled = true;
		});
	}

	removeFromList(i){
		var array = [...this.state.petition_components];
		array.splice(i, 1);
		this.setState({petition_components: array});
		
	}

	removePlasmatic(i){
		var array = [...this.state.plasmaticAdded];
		array.splice(i, 1);
		this.setState({plasmaticAdded: array});
	}

	newSample(e){
		e.preventDefault();
  		var group_rh = this.state.lookup_group !== null && this.state.lookup_group !== "" ?
							this.state.lookup_group+
							(this.state.lookup_rh === 'POSITIVO' ? '+' :
								this.state.lookup_rh === 'NEGATIVO' ? '-' : '')
						:'';

		var name = this.state.patient_lastname1 +' '+ this.state.patient_lastname2 +' '+ this.state.patient_name;
		
		var option = this.props.match.params.id === undefined ? 'register' : 'assign';

		var index = this.state.facility_sections.findIndex(obj => obj.key === this.state.health_services);
		var service = index !== -1 ? this.state.facility_sections[index].name : "";

  		this.modal_samples.handleShow(
  			this.props.match.params.id, 
  			this.state.patient_id, 
  			name, 
  			group_rh, 
  			option,
  			service,
  		);
  		//this.props.history.push('/petition_samples/new/'+id+'/'+petition);*/
  	}

  	getList(){
  		this.props.getValues();
  	}

  	openFamiliar(e){
  		e.preventDefault();
  		this.modal_familiar.handleShow();
  	}

  	setFamiliar(obj){
  		if(this.props.match.params.id !== undefined){
  			obj.petition_id = this.props.match.params.id;
  		}
  		this.setState({petition_family_responsable:obj});
  	}

  	samples(e, id){
		e.preventDefault();
		this.modal_info.handleShow(id)
  		//this.props.history.push('/petition_register/edit/'+id);
  		setTimeout(()=>{
  			//this.props.getValues();
  		}, 500);
  	}

  	deleteProcess(e, item, type){
  		e.preventDefault();
  		var url = '';
  		var method = '';
  		var obj = {};

  		if(type === 'Devolución'){
  			url = 'returns_delivery/'+item.returns_id;
  			method = 'DELETE'
  			//type = 'Devolución';

  		}else if(type === 'Envío'){
  			url = 'unit_delivered/'+item.delivered_id;
  			method = 'DELETE';
  			//type = 'Envío';

  		}else if(type === 'Reserva'){
  			url = 'units/remove_reserved';
  			method = 'POST';
  			obj = [item.reserved_id];
  			//type = 'Reserva';

  		}


  		swal({
	        title: '¿Está seguro?',
	        text: 'Desea eliminar '+type,
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: 'Eliminar!',
	        cancelButtonText: '¡Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    },  (isConfirm)=> {
	        if (isConfirm) {
	        	this.props.waiting.handleShow('Cargando...');
				fetch(Config.default.apiGateway.URL+url, {
		  			method : method,
		  			body:JSON.stringify(obj),
		  			headers: new Headers({
		  				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
		  				'Accept'		: 'application/json',
		  				'Content-Type'	: 'application/json'
		  			})
		  		}).then(res => {
		  			this.props.waiting.handleClose();
		  			if(res.ok){
		  				return res.json();
		  			}else{
		  				res.text().then((msg)=>{
		  					swal("Error", msg, 'error');
		  				})
		  			}
		  		})
		  		.then(response=>{
		  			if(response !== undefined){
		  				this.props.getTableUnits();
		  				swal('Success', 'El registro se elimino correctamente', 'success');
		  			}	
		  		})
	        }
	    });
  	}

  	person_search(){
		this.modal_person_search.handleShow('Paciente','patients');
	}

	getAnswersApheresis(){
		var obj = {}, res =[];

		this.state.campos.map((s)=>{
			obj = {
				apheresis_field_id: s.id,
				value: document.getElementById(s.id) !== null ? document.getElementById(s.id).value : ""
			}

			var index = this.state.apheresis_fields_values.indexOf(obj => 
				obj.apheresis_field_id === s.id
			);

			if(index !== -1){
				obj.id = this.state.apheresis_fields_values[index].id;
				obj.petition_id = this.state.apheresis_fields_values[index].petition_id;

				if(obj.value !== ""){
					res.push(obj);
				}
			}else{
				if(obj.value !== ""){
					res.push(obj);
				}
			}
		})
		
		return res;
	}

	async printConcent(e, id){
		e.preventDefault();
		this.props.waiting.handleShow('Imprimiendo...');
        
      	var obj ={};
      	obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;

      	obj.file_type = "INFORMED_CONSENT_" + this.state.petition;
      	obj.nEtiqueta = [0];

      	var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		
		this.props.waiting.handleClose();
		

	}

	async printCard(e, id){
		e.preventDefault();
		this.props.waiting.handleShow('Imprimiendo...');
        
      	var obj ={};
      	obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;

      	obj.file_type = "patient_identification_card";
      	obj.nEtiqueta = [0];

      	var type = await this.props.getDocumentType(obj.file_type);

		if(type !== undefined){
			var document;
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}
		}
		
		this.props.waiting.handleClose();

	}

	async printLetter(e, id){
		e.preventDefault();
		this.props.waiting.handleShow('Imprimiendo...');
        
      	var obj ={};
      	obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = id;

      	obj.file_type = "commitment_letter";
      	obj.nEtiqueta = [0];

      	var type = await this.props.getDocumentType(obj.file_type);

		if(type !== undefined){
			var document;
			if(type.print_type === 'template'){
				document = await this.props.printDocumentTemplate(obj, type.print_automatically);
			}else if(type.print_type === 'external'){
				document = await this.props.printDocumentExternal(obj, type.print_automatically);
			}
		}
		
		this.props.waiting.handleClose();

	}

	addCenter(){
		this.modal_add_center.handleShow();
	}

	openConditions(e){
		e.preventDefault();

		this.modal_conditions.handleShow(this.state.patient_id, this.props.match.params.id, 'petition_form');
	}

	autocompleteHandle = (name,value) => {
		this.setState({[name]:value});
	}
	_handleSearchJob = (query) => {
		
	}

	addPhoneToList = (phone) => {
		
		this.setState({ phonesAdded: [...this.state.phonesAdded, phone]});
	}

	removePhoneFromList = (indice) => {
		if(!this.state.disableOnView){
			var array = [...this.state.phonesAdded];
			array.splice(indice, 1);
			this.setState({phonesAdded: array});
		}
	}
	formatString = (str) => {
		// Convierte a mayúsculas y quita acentos y diéresis
		return str
		  .toUpperCase()
		  //.normalize('NFD')
		  .replace(/[\u0300-\u036f]/g, '');
	  }
	  formatStringFinal = (str) => {
		// Convierte a mayúsculas y quita acentos y diéresis
		return str
		  //.toUpperCase()
		  .normalize('NFD')
		  .replace(/[\u0300-\u036f]/g, '');
	  }
	generarRFC = (e) => {
		e.preventDefault();
		const { patient_name, patient_lastname1, patient_lastname2, birthdate } = this.state;
		var statusName = false;
		var statusLastname1 = false;
		var statusbirthdate = false;
if (patient_name !="" ) {
	console.log(patient_name);
	document.getElementById('patient_name').style.borderColor = "#ccc";
				document.getElementById('patient_name').classList.remove("error");
				//this.setState({statusName: true})
				statusName = true;
}else{
	document.getElementById('patient_name').classList.add("error");
				document.getElementById('patient_name').style.borderColor = "red";
				//this.setState({statusName: false})
				statusName= false;
}
if (patient_lastname1 !="") {
	document.getElementById('patient_lastname1').style.borderColor = "#ccc";
				document.getElementById('patient_lastname1').classList.remove("error");
				//this.setState({statusLastname1 : true})
				statusLastname1 = true;
}else{
	document.getElementById('patient_lastname1').classList.add("error");
				document.getElementById('patient_lastname1').style.borderColor = "red";
				//this.setState({statusLastname1 : false})
				statusLastname1 = false;
}
if (birthdate !="" ) {
	document.getElementById('birthdate').style.borderColor = "#ccc";
				document.getElementById('birthdate').classList.remove("error");
				//this.setState({statusbirthdate : true})
				statusbirthdate = true;
}else{
	document.getElementById('birthdate').classList.add("error");
				document.getElementById('birthdate').style.borderColor = "red";
				//this.setState({statusbirthdate : false})
				statusbirthdate = false;
}
if (statusName && statusLastname1 && statusbirthdate) {
    // Formatea los datos antes de generar el RFC
    const formattedNombre = this.formatString(patient_name);
    const formattedPrimerApellido = this.formatString(patient_lastname1);
    const formattedSegundoApellido = this.formatString(patient_lastname2);
    // Obtener el año (los dos últimos dígitos)
  const birthYear = birthdate.substring(8, 10);

  // Obtener el mes y anteponer un cero si es menor a 10
  const birthMonth = birthdate.substring(3, 5);

  // Obtener el día y anteponer un cero si es menor a 10
  const birthDay = birthdate.substring(0, 2);
  // Función para reemplazar "Ñ" por "X" en un apellido
  const replaceSpecialCharacter = (apellido) => {
    return apellido.replace('Ñ', 'X');
  };

  var apellido = formattedPrimerApellido.split(" ");
  var apellidoCompuesto;
  if (apellido[0] === "DA" ||
  apellido[0] === "DAS" ||
  apellido[0] === "DE" ||
  apellido[0] === "DEL" ||
  apellido[0] === "DER" ||
  apellido[0] === "DI" ||
  apellido[0] === "DIE" ||
  apellido[0] === "DD" ||
  apellido[0] === "EL" ||
  apellido[0] === "LA" ||
  apellido[0] === "LOS" ||
  apellido[0] === "LAS" ||
  apellido[0] === "LE" ||
  apellido[0] === "LES" ||
  apellido[0] === "MAC" ||
  apellido[0] === "MC" ||
  apellido[0] === "VAN" ||
  apellido[0] === "VON" ||
  apellido[0] === "Y") {
	apellidoCompuesto = apellido[1];
  }else{
	apellidoCompuesto = apellido[0];
  }
// Obtener la letra inicial del primer apellido
const firstLetterApellido1 = replaceSpecialCharacter(apellidoCompuesto);
const apellido1 = firstLetterApellido1.charAt(0);
// Obtener la primera vocal interna del primer apellido
const vowels = ['A','Á', 'E', 'É', 'I', 'Í', 'O', 'Ó', 'U', 'Ú'];
let firstVowelApellido1 = '';
for (let i = 1; i < firstLetterApellido1.length; i++) {
  if (vowels.includes(firstLetterApellido1.charAt(i))) {
	//console.log(firstLetterApellido1.charAt(i));
	firstVowelApellido1 = firstLetterApellido1.charAt(i);
	break;
  }else{
	firstVowelApellido1= "X" 
  }
}

// Obtener la letra inicial del segundo apellido
const firstLetterApellido2 = replaceSpecialCharacter(formattedSegundoApellido);
var apellido2 = firstLetterApellido2.charAt(0);
if (apellido2 ==="") {
	apellido2 ="X";
}
var nombre = formattedNombre.split(" ");
//console.log(nombre);
var nombreCompuesto;
if (nombre.length>1) {
	if (nombre[0] === "MARIA" ||
	nombre[0] === "MA." ||
	nombre[0] === "MA" ||
	nombre[0] === "JOSE" ||
	nombre[0] === "J" ||
	nombre[0] === "J.") {
		//console.log(nombre[1]);
		//console.log("El nombre tiene más de una parte.");
		nombreCompuesto = nombre[1];
	}else{
		nombreCompuesto =nombre[0];
	}
} else {
	//console.log(nombre[0]);
	nombreCompuesto =nombre[0];
  //console.log("El nombre tiene una sola parte o está vacío.");
}
////console.log(nombreCompuesto)
// Obtener la primera letra del nombre
const firstLetterName = nombreCompuesto.charAt(0); 
//	console.log(birthYear,birthMonth,birthDay);
const fva1= this.formatStringFinal(firstVowelApellido1);
const fln = this.formatStringFinal(firstLetterName);
const aComparar = `${apellido1}${fva1}${apellido2}${fln}`;
//console.log(aComparar);
var cadenasAComparar = [
	"BACA", "BAKA", "BUEI", "BUEY", "CACA", "CACO", "CAGA", "CAGO", "CAKA", "CAKO",
	"COGE", "COGI", "COJA", "COJE", "COJI", "COJO", "COLA", "CULO", "FALO", "FETO",
	"GETA", "GUEI", "GUEY", "JETA", "JOTO", "KACA", "KACO", "KAGA", "KAGO", "KAKA",
	"KAKO", "KOGE", "KOGI", "KOJA", "KOJE", "KOJI", "KOJO", "KOLA", "KULO", "LILO",
	"LOCA", "LOCO", "LOKA", "LOKO", "MAME", "MAMO", "MEAR", "MEAS", "MEON", "MIAR",
	"MION", "MOCO", "MOKO", "MULA", "MULO", "NACA", "NACO", "PEDA", "PEDO", "PENE",
	"PIPI", "PITO", "POPO", "PUTA", "PUTO", "QULO", "RATA", "ROBA", "ROBE", "ROBO",
	"RUIN", "SENO", "TETA", "VACA", "VAGA", "VAGO", "VAKA", "VUEI", "VUEY", "WUEI",
	"WUEY"
  ];
  var nuevaClave = "";
// Iteramos sobre las cadenas a comparar
for (var i = 0; i < cadenasAComparar.length; i++) {
	// Comparamos si la cadena coincide con alguna de las cadenas de la lista
	if (aComparar === cadenasAComparar[i]) {
	  // Si coincide, reemplazamos el segundo dígito con "X"
	  nuevaClave = aComparar.substring(0, 1) + "X" + aComparar.substring(2);
	  //console.log("Coincidió con:", cadenasAComparar[i]);
	  //console.log("Número modificado:", nuevaClave);
	  break; // Terminamos la iteración una vez que hay una coincidencia
	}else{
		nuevaClave = aComparar;
	}
  }
// Combinar las partes para formar el RFC
const rfc = `${nuevaClave}${birthYear}${birthMonth}${birthDay}`;
this.setState({ patient_rfc: rfc});
}else{
	this.setState({patient_rfc:""})
}

	  }
	render(){
		const {t} = this.props;

		return (
			<div>
				<div className="col-xs-9">
					{this.props.match.params.id === undefined ?
						<div className="col-xs-12 form-group">
							<div className="col-xs-12 col-sm-7">
								<AsyncTypeahead
						          	labelKey={(option) => `${option.names}`}
						          	minLength={0}
						          	options={this.state.patient_list}
						          	onSearch={this.handleSearch}
						          	onChange={this.getInfo}
						          	name="patient_id"
						          	id="patient_id"
						          	isLoading={this.state.loading_patient}
						          	reuired={true}
						          	placeholder="Buscar por apellidos más nombre o número de documento"
						          	ref={ref => this._typeahead = ref}
						          	useCache={false}
						          	delay={800}
						          	paginationText="Mostrar mas resultados..."
						        />
							</div>

							<div className="col-xs-12 col-sm-5">
								<SvgIcon className={this.state.patient_id !== "" ? "spin-patient" : "spin"} size={25} icon={spinner11} title="Paciente"/>
								<SvgIcon icon={search} size={20} style={{cursor:'pointer', marginLeft:'10px'}} 
									onClick={this.person_search}/>
                                <button type="button" className="btn btn-info" 
                                    style={{marginLeft:10, marginRight:10}}
									onClick={this.newPatient}>
									{t('content.generics.buttons.new')}
								</button>
								{this.state.imss_search.value === 'YES' &&
									<button
										type="button" className="btn btn-info button-min" 
										onClick={()=>this.search_imss.handleShow('patient')}>
										Busqueda IMSS
									</button>
								}
								{this.state.isste_search === 'YES' && 
									<button
										type="button" className="btn btn-info button-min" 
										onClick={()=>this.isste_search.handleShow('patient')}>
										Busqueda ISSTE
									</button>
								} 
								
							</div>
						</div>
					:null}

					<fieldset className="col-xs-12">
						<legend>
							<a 
								href="#" 
								onClick={
									(e)=>{
										e.preventDefault(); 
										this.setState({hide_patient: this.state.hide_patient ? false : true});
									}
								}>
								Paciente
							</a>
						</legend>

						{!this.state.hide_patient ?
							<div>
								{this.state.patient_id !== "" ?
									<div className="col-xs-12">
										<input className="form-check-input" type="checkbox" name="blockFields" id="blockFields"
											style={{marginRight: "5px"}} onChange={this.handleChange}/>
										<span className="span-min">Editar Datos</span>
									</div>
								:null}

                                <div className="col-xs-12">
                                    {this.state.fields_patient.map((field, i)=>
                                        field.print ?
                                            field.key === 'PATIENT_NAME' ?
                                                <div className="col-xs-12 col-sm-3" key={i}>
                                                    <span className="span-min">Nombre(s)</span>

                                                    <input className="form-control" type="text" name="patient_name" id="patient_name" 
                                                        value={this.state.patient_name || ""} required={field.required}
                                                        onKeyPress={(e) => this.props.validate(e)}
                                                        onChange={this.handleChange} disabled={this.state.fromImss ? true : this.state.disableFields}	/>
                                                </div>
                                            : field.key === 'PATIENT_LASTNAME1' ?
                                                <div className="col-xs-12 col-sm-2" key={i}>
                                                    <span className="span-min">A. Paterno</span>            
                                                    <input className="form-control" type="text" name="patient_lastname1" id="patient_lastname1"
                                                        value={this.state.patient_lastname1 || ""} required={field.required}
                                                        onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} 
                                                        disabled={this.state.fromImss ? true : this.state.disableFields} />
                                                </div>
                                            : field.key === 'PATIENT_LASTNAME2' ?
                                                <div className="col-xs-12 col-sm-2" key={i}>
                                                    <span className="span-min">A. Materno</span>
            
                                                    <input className="form-control" type="text" name="patient_lastname2" id="patient_lastname2" 
                                                        value={this.state.patient_lastname2 || ""} required={field.required}
                                                        onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} disabled={this.state.fromImss ? true : this.state.disableFields} />
                                                </div>
                                            : field.key === 'PATIENT_BIRTHDAY' ?
                                                <div className="col-xs-12 col-sm-2" key={i}>
                                                    <span className="span-min">F. Nacimiento</span>

                                                    <MaskedFormControl type='text' name="birthdate" id="birthdate" value={this.state.birthdate || ""}
                                                        onChange={this.dateHandleChange} mask='11/11/1111' placeholder="dd/mm/yyyy" 
                                                        onKeyPress={(e) => this.props.validate(e)} required={field.required}
                                                        className="form-control input-date" disabled={this.state.fromImss ? true : this.state.disableFields}/>
                                                </div>
                                            : field.key === 'PATIENT_AGE' ?
                                                <div key={i}>
                                                    <div className="col-xs-12 col-sm-1">
                                                        <span className="span-min">
                                                            <input type="checkbox" name="check_age" id="check_age" style={{margin:0, marginRight:5}}
                                                                value={this.state.check_age} checked={this.state.check_age} 
                                                                 onChange={this.handleChange} disabled={this.state.fromImss ? true : this.state.disableFields} />
                                                            Edad
                                                        </span>

                                                        <input className="form-control" type="text" name="age" id="age" value={
                                                            this.state.age === '0' ? '0' : this.state.age || ""} required={field.required}
                                                            onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange}
                                                            disabled={this.state.fromImss ? true : this.state.disableFields ? true :	this.state.check_age ? false : true} />
                                                    </div>

                                                    <div className="col-xs-12 col-sm-2">
                                                        <span className="span-min">Tipo</span>
                                                        <select className="form-control" name="age_type" id="age_type" value={this.state.age_type} required={field.required}
                                                            onChange={this.handleChange} disabled={this.state.disableFields ? true : this.state.check_age ? false : true}>
                                                            <option value="DAYS">DIAS</option>
                                                            <option value="MONTHS">MESES</option>
                                                            <option value="YEARS">AÑOS</option>
                                                        </select>
                                                    </div>
                                                </div>
												: field.key === 'PATIENT_RFC' ?
                                                <div className="col-xs-12 col-sm-4" key={i}>
													<div className='col-xs-6 '>
														<span className="span-min">RFC:</span>
														<input className="form-control" type="text" name="patient_rfc" id="patient_rfc" 
																value={this.state.patient_rfc || ""} required={field.required}
																onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} disabled={true} />
													</div>
												   <div className='col-xs-6 mt-3'>
														<span className="span-min mt-1"></span>
														<button type="button" className="btn btn-info  mt-1" onClick={(e)=>{this.generarRFC(e);e.preventDefault()}}>Generar RFC</button>                                     
												   </div>
                                                </div>
                                            : field.key === 'DOCUMENT_NUMBER' ?
                                                <div key={i}>
                                                    <div className="col-xs-12 col-sm-2">
                                                        <span className="span-min">Tipo Documento</span>
                                                        <select name="document_type" className="form-control" value={this.state.document_type || ""} 
                                                            onKeyPress={(e) => this.props.validate(e)} required={field.required}
                                                            onChange={this.handleChange} disabled={this.state.disableFields}>
                                                            <option value="">Seleccione...</option>
                                                            {this.state.documents.map((d, i)=>{
                                                                return <option key={i} value={d.key}>
                                                                    {d.name}
                                                                </option>
                                                            })}
                                                        </select>
                                                    </div>

                                                    <div className="col-xs-12 col-sm-2">
                                                        <span className="span-min">No. Doc.</span>
                                                        <input className="form-control" type="text" name="document_number" required={field.required}
                                                            disabled={this.state.disableFields} onKeyPress={(e) => this.props.validate(e)}
                                                            value={this.state.document_number} onChange={this.handleChange} />
                                                    </div>
                                                </div>
											:  field.key === 'PATIENT_SEX' ?
												<div className="col-xs-12 col-sm-2"  key={i}>
													<span className="span-min">{t('content.offers.form.gender')}</span>
													<select className="form-control" id="patient_sex" name="patient_sex"
														style={{padding:0}} required={field.required}
														onKeyPress={(e) => this.props.validate(e)} disabled={this.state.fromImss ? true : this.state.disableFields}
														onChange={this.handleChange}
														value={this.state.patient_sex} > 
														<option value="" >Seleccionar...</option>
														<option value="HOMBRE" >HOMBRE</option>
														<option value="MUJER" >MUJER</option>
													</select>
												</div>
											 :field.key === 'CLINIC_HISTORY' ?
												<div className="col-xs-12 col-sm-2" key={i}>
													<span className="span-min">No. Expediente</span>
			
													<input className="form-control" type="text" name="clinic_history" id="clinic_history"
														disabled={this.state.disableFields} onKeyPress={(e) => this.props.validate(e)} required={field.required}
														value={this.state.clinic_history || ""} onChange={this.handleChange} />
												</div>
											 :field.key === 'SOCIAL_NUMBER' ?
												<div className="col-xs-12 col-sm-2" key={i}>
													<span className="span-min" style={{fontSize:"11px"}}>No. IMSS</span>
			
													<input className="form-control" type="text" name="social_number" id="social_number" required={field.required}
														disabled={this.state.fromImss ? true : this.state.disableFields} onKeyPress={(e) => this.props.validate(e)}
														value={this.state.social_number || ""} onChange={this.handleChange}/>
												</div>
											:field.key === 'PATIENT_CURP' ?
											<div className="col-xs-12 col-sm-2" key={i}>
												<span className="span-min" style={{fontSize:"11px"}}>CURP</span>
		
												<input className="form-control" type="text" name="curp_issste" id="curp_issste" required={field.required}
													disabled={this.state.fromImss ? true : this.state.disableFields} onKeyPress={(e) => this.props.validate(e)}
													value={this.state.curp_issste || ""} onChange={this.handleChange}/>
											</div>
											: field.key === 'PATIENT_IDEE' ?
												<div className='col-xs-12 col-sm-2' key={i}>
													<span className='span-min'>IDEE</span>
													<input className="form-control" name="patient_idee" disabled
														id="patient_idee" value={this.state.patient_idee} onChange={this.handleChange} />
												</div>
											
											
                                            :null
                                        :null
                                    )}									

									
                                 
									{this.state.fields_patient.map((field, i)=>
										field.print ?
											field.key === 'PATIENT_NUMBER' ?
												<div className="col-xs-12 col-sm-2" key={i}>
													<span className="span-min">Número de Paciente</span>
													<input className="form-control hour-input"  
														name="patient_number" id="patient_number" required={field.required}
														disabled={this.state.disableFields ? true : this.state.pac_usr_npm === 'NO'}
														value={this.state.patient_number} onChange={this.handleChange} />
												</div>
											: field.key === 'PATIENT_CIVIL_STATUS' ?
												<div className=" col-xs-12 col-sm-2"  key={i}>
													<span className="span-min">{t('content.offers.form.civil_status')}</span>
													<select className="form-control" disabled={this.state.disableFields}
														name="civil_status" id="civil_status" value={ this.state.civil_status } 
														onChange={ this.handleChange }
														onKeyPress={(e) => this.props.validate(e)} required={field.required}
														> 
														<option value="" disabled>Seleccionar...</option>
														{
															this.state.civil_status_array.map(function(t) {
					
															return <option key={t.id}  value={t.key} >{t.name} </option>;
															})
														}
													</select>
												</div>
											: field.key === 'PATIENT_JOB_PROFILE' ?
												<div className="col-xs-12 col-sm-4" key={i}>
													<span className="span-min">{t('content.offers.form.job_profile')}</span>
													<AsyncTypeahead 
														/*{...this.state}*/
														disabled={this.state.disableFields}
														labelKey={(option) => `${option.name}`}
														minLength={0}
														name="job_profile" id="job_profile"
														onKeyPress={(e) => this.props.validate(e)}
														options={this.state.jobProfiles}
														onChange={this.handleTypeAheadChange('job_profile')}
														onSearch={this._handleSearchJob}
														defaultSelected={this.state.jobProfiles.slice(this.state.indice_job, 1)}
														selected={this.state.jobSelected}
														inputProps={{
															required:field.required, 
															id:'job_profile'
														}}
														ref="_handleSearch_job"
														useCache={false}	
														isLoading={this.state.isLoading}
														delay={600}
														paginationText="Mostrar mas resultados..."
													/>
												</div>
											:null
										:null
									)}

									<div className="col-xs-12 col-sm-2">
										<span className="span-min">F. Ultimo Envio</span>
										<input className="form-control" type="text" value={this.state.last_unit_date || ""} 
											disabled />
									</div>

									<div className="col-xs-12 col-sm-2">
										<span className="span-min">Unidades Reservadas</span>
										<input className="form-control" type="text" disabled 
											value={this.state.unit_reserved === "" ? '' : this.state.unit_reserved ? 'SI' : 'NO' } />
									</div>

									
								
									{this.state.special_patient.length > 0 &&
										this.state.special_patient.map((s, i)=>(
											i === 0 ?
												<div className="col-xs-12 col-sm-3" key={i}>
													<span className="span-min">{s.Etiqueta}</span>
													{Parser(s.html)}
												</div>
											: <div className="col-xs-12 col-sm-3" key={i}>
													<span className="span-min">{s.Etiqueta}</span>
													{Parser(s.html)}
												</div>
										))									
									}

									<div className={this.state.show_phone ? 'col-xs-12 col-sm-8' : 'col-xs-12'} style={{padding:0}}>
										<>
											{this.state.fields_patient.length > 0 &&
												<Address 
													{...this.props}
													state={this.state}
													validate={this.props.validate}
													handleChange={this.handleChange} 
													selectFieldHandle={this.handleChange} 
													autocompleteHandle={this.autocompleteHandle}
													onRef={ref => (this.address = ref)}
												/>
											}
										</>

										<div className="col-xs-12 col-sm-3">
											<span className="span-min">Tipo de Petición</span>
											<select className="form-control" name="petition" id="petition" 
												onKeyPress={(e) => this.props.validate(e)} disabled={this.props.state.disabledFields}
												value={this.state.petition || ""} onChange={this.handleChange} required>
												<option value="">Seleccione...</option>
												{this.state.type_petitions.map((p, i)=>{
													return <option key={i} value={p.key}>
														{p.name}
													</option>
												})}
											</select>
										</div>                                	
									</div>
									{this.state.show_phone &&
										<div className='col-xs-12 col-sm-4' style={{padding:0}}>
											<Phone 
												disableElement={this.state.disableFields} 
												phonesAdded={this.state.phonesAdded} 
												state={this.state} 
												submenu={this.props.location.pathname}
												handleChange={this.handleChange} 
												selectFieldHandle={this.handleChange} 
												addPhoneToList={this.addPhoneToList} 
												removePhoneFromList={this.removePhoneFromList}
											/>
										</div>
									}
                                </div>
									
							</div>
						:null}
							

					</fieldset>

                    <fieldset className="col-xs-12">
                        <legend>{this.state.petition_type}</legend>

                        <div className="col-xs-12">
                            {this.state.fields.map((field, i)=>
                                field.print ?
                                    field.key === 'PETITION_TYPE' ?
                                        <div className="col-xs-12 col-sm-3" key={i}>
                                            <span className="span-min">Petición</span>
                                            <select className="form-control" name="petition_type" id="petition_type" 
                                                value={this.state.petition_type} onKeyPress={(e) => this.props.validate(e)}
                                                onChange={this.handleChange} required={field.required}
                                                disabled={this.props.state.disabledFields ? true :
                                                            this.state.petition !== 'LABORATORY' && this.state.petition !== 'APHERESIS' ? true : false}>
                                                <option value="">Seleccione...</option>
                                                {this.state.petitions.map((p, i)=>(
                                                    <option key={i} value={p.name}>{p.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                    :field.key === 'PETITION_DATE' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Fecha</span>
                                            <input className="form-control hour-input" type="date" name="date" id="date" 
                                                value={this.state.date || ""} required={field.required}
                                                onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange}  
                                                disabled={this.props.state.disabledFields ? true :
                                                    this.state.pat_change_date_petition.value === 'NO' ? true : false
                                                }	
                                            />
                                        </div>
                                    :field.key === 'PETITION_HOUR' ?
                                        <div className="col-xs-12 col-sm-1" key={i}>
                                            <span className="span-min">Hora</span>

                                            <input id="hour" name="hour" type="text" data-inputmask-alias="datetime" data-inputmask-inputformat="HH:MM"  
                                                data-inputmask-placeholder="-" value={this.state.hour || ""} onKeyPress={(e) => this.props.validate(e)}
                                                className="form-control" onChange={this.handleChange}  required={field.required}
                                                disabled={this.props.state.disabledFields ? true :
                                                    this.state.pat_change_date_petition.value === 'NO' ? true : false
                                                }
                                            />
                                        </div>
                                    :field.key === 'PETITION_NUMBER' ?
                                        <div className="col-xs-12 col-sm-1" key={i}>
                                            <span className="span-min" style={{fonSize:'12px'}}>No. Petición</span>

                                            <input className="form-control" type="text" name="petition_number" id="petition_number" onKeyPress={(e) => this.props.validate(e)}
                                                required={field.required} value={this.state.petition_number || ""} 
                                                onChange={this.handleChange}  disabled={this.props.state.disabledFields} />
                                        </div>
                                    :field.key === 'EPISODIO' ?
                                        <div className={"col-xs-12 col-sm-1"} key={i}>
                                            <span className="span-min">Episodio</span>
                                            <input type="text" className="form-control" name="petition_episodio" id="petition_episodio" 
                                                onKeyPress={(e) => this.props.validate(e)} required={field.required}
                                                value={this.state.petition_episodio || ""}  onChange={this.handleChange}  disabled={this.props.state.disabledFields} />
                                        </div>
                                    :field.key === 'PRIORITY' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Prioridad</span>
                                            <select className="form-control" name="petition_component_priority" id="petition_component_priority"
                                                onKeyPress={(e) => this.props.validate(e)}  disabled={this.props.state.disabledFields}
                                                value={this.state.petition_component_priority || ""}  required={field.required}
                                                onChange={this.handleChange}
                                                style={{padding:"0 5px"}}>
                                                <option value="">Seleccione...</option>
                                                {this.state.options_petition_component_priority.map(function (p) {
										return <option key={p.id} value={p.name}>{p.name}</option>;
									})}
                                            </select>
                                        </div>
                                    :field.key === 'WORK_SESSION' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Sesión</span>
                                            <select required className="form-control" disabled value={ this.state.work_sessions_id } 
                                                onChange={ this.handleChange } required={field.required}
                                                name="work_sessions_id" id="work_sessions_id">
                                                {this.state.work_sessions.map(function(t) {
                                                    return <option  key={t.id}  value={t.id} >{t.type_value} </option>;
                                                })}
                                                </select>
                                        </div>
                                    :null
                                :null
                            )}
                        </div>
                        <div className="col-xs-12">
                            {this.state.fields.map((field, i)=>
                                field.print ?
                                    field.key === 'ORIGIN_CENTER' ?
                                        <div className="col-xs-12 col-sm-5" key={i}>
                                            <div><span className="span-min">Origen</span></div>
                                            
                                            <div style={{width:this.state.user_add_center === 'YES' ? '90%' : '100%', display:'inline-block'}}>
                                                <AsyncTypeahead
                                                    labelKey={(option) => `${option.name}`}
                                                    minLength={0}
                                                    inputProps={{
                                                        name:"origin_center_id",
                                                        disabled:this.props.state.disabledFields,
                                                        id:"origin_center_id",
                                                        required:field.required
                                                    }}
                                                    disabled={this.props.state.disabledFields}
                                                    id="originCenterId"
                                                    options={this.state.health_facilities}
                                                    onChange={this.handleTypeAheadChange('origin_center_id')}
                                                    onSearch={this._handleSearch2}
                                                    defaultSelected={this.state.health_facilities.slice(this.state.indice, 1)}
                                                    selected={this.state.requestedSelected}
                                                    ref={ref => this._typeahead_origin = ref}
                                                    isLoading={this.state.isLoading}
                                                    onKeyPress={(e) => this.props.validate(e)}
                                                    useCache={false}
                                                    delay={600}
                                                    paginationText="Mostrar mas resultados..."
                                                />
                                            </div>
                                            {this.state.user_add_center === 'YES' &&
                                                <div style={{width:'10%', display:'inline-block', textAlign:'center'}}>
                                                    <FloatingActionButton className="action-btn" iconStyle={{height: 20, width: 20}} mini={true} 
                                                        onClick={this.addCenter} disabled={this.props.state.disabledFields} >
                                                        <ContentAdd/>
                                                    </FloatingActionButton> 
                                                </div>
                                            }
                                            
                                        </div>
                                    :field.key === 'HEALTH_SERVICES' ?
                                        <div className="col-xs-12 col-sm-3" key={i}>
                                            <span className="span-min">Servicio</span>
                                            <select className="form-control" name="health_services" id="health_services" required={field.required}
                                                onKeyPress={(e) => this.props.validate(e)}  disabled={this.props.state.disabledFields}
                                                value={this.state.health_services || ""} onChange={this.handleChange}>
                                                <option value="">Seleccione...</option>
                                                {this.state.facility_sections.map((f, i)=>{
                                                    return <option key={i} value={f.key}>
                                                        {f.name}
                                                    </option>
                                                })}
                                            </select>
                                        </div>
                                    :field.key === 'UBICATION' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Ubicación</span>
                                            <input type="text" className="form-control" name="petition_ubication" id="petition_ubication" 
                                                onKeyPress={(e) => this.props.validate(e)} required={field.required}
                                                value={this.state.petition_ubication || ""} onChange={this.handleChange}  disabled={this.props.state.disabledFields} />
                                        </div>
                                    :field.key === 'CEDULA_MEDICO' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Cédula Médico</span>
                                            <input type="text" className="form-control" name="cedula_doctor" id="cedula_doctor" 
                                                onKeyPress={(e) => this.props.validate(e)} required={field.required}
                                                value={this.state.cedula_doctor || ""} onChange={this.handleChange}  disabled={this.props.state.disabledFields} />
                                        </div>
                                    :null
                                :null
                            )}
                        </div>
                        <div className="col-xs-12">
                            {this.state.fields.map((field, i)=>
                                field.print ?
                                    field.key === 'DOCTOR' ?
                                        <div className="col-xs-12 col-sm-3" key={i}>
                                            <span className="span-min">Médico</span>
                                            <input type="text" className="form-control" name="petition_doctor" id="petition_doctor" 
                                                onKeyPress={(e) => this.props.validate(e)} required={field.required}
                                                value={this.state.petition_doctor || ""} onChange={this.handleChange}  disabled={this.props.state.disabledFields}
                                                style={{padding:'3px'}} />
                                        </div>       
                                    :field.key === 'SOLICITEDFOR_DATE' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Previsto Para</span>
                                            <input className="form-control hour-input" type="date" name="solicited_date" id="solicited_date" 
                                                onKeyPress={(e) => this.props.validate(e)} required={field.required}
                                                value={this.state.solicited_date || ""} onChange={this.handleChange}  disabled={this.props.state.disabledFields} />
                                        </div>
                                    :field.key === '' ?
                                        <div className="col-xs-12 col-sm-1" key={i}>
                                            <span className="span-min">Hora</span>
                                            <input id="solicited_hour" name="solicited_hour" id="solicited_hour" type="text"
                                                data-inputmask-alias="datetime"  data-inputmask-inputformat="HH:MM"  
                                                data-inputmask-placeholder="-" className="form-control" required={field.required}
                                                onKeyPress={(e) => this.props.validate(e)}  disabled={this.props.state.disabledFields}
                                                value={this.state.solicited_hour || ""}  onChange={this.handleChange} />
                                        </div>	
                                    :field.key === 'STATUS' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Estatus</span>
                                            <input type="text" className="form-control" name="petition_status" id="petition_status" 
                                                onKeyPress={(e) => this.props.validate(e)} required={field.required}
                                                value={this.state.petition_status || ""} onChange={this.handleChange}  disabled={this.props.state.disabledFields} />
                                        </div>
                                    :field.key === 'REASON' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Motivo</span>
                                            <select className="form-control" name="petition_reason" id="petition_reason" 
                                                value={this.state.petition_reason || ""} required={field.required}
                                                onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange}  disabled={this.props.state.disabledFields}>
                                                <option value="">Seleccione...</option>
                                                {this.state.reasons.map((r, i)=>{
                                                    return <option key={i} value={r.key}>
                                                        {r.name}
                                                    </option>
                                                })}
                                            </select>
                                        </div>
                                    :field.key === 'SURGERY_TYPE' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Tipo Cirugía</span>
                                            <select className="form-control" name="petition_component_surgery_type" id="petition_component_surgery_type"
                                                onKeyPress={(e) => this.props.validate(e)}  disabled={this.props.state.disabledFields} 
                                                value={this.state.petition_component_surgery_type || ""} required={field.required}
                                                onChange={this.handleChange}>
                                                <option value="">Seleccione...</option>
                                            </select>
                                        </div>
                                    :null
                                :null
                            )}
                        </div>
                        <div className="col-xs-12">
                            {this.state.fields.map((field, i)=>
                                field.print ?
                                    field.key === 'DIAGNOSIS' ?
                                        <div className="col-xs-12 col-xs-5" key={i}>
                                            <span className="span-min">Diagnóstico</span>
                                            {this.state.pat_diag_type.value === 'OPEN' ? 
                                                <input type="text" className="form-control" name="petition_diagnosis" id="petition_diagnosis"
                                                    onKeyPress={(e) => this.props.validate(e)}  disabled={this.props.state.disabledFields}
                                                    required={field.required}
                                                    value={this.state.petition_diagnosis || ""} onChange={this.handleChange} />
                                            :<select className="form-control" value={this.state.petition_diagnosis} onChange={this.handleChange}
                                                required={field.required} disabled={this.props.state.disabledFields} 
                                                name="petition_diagnosis" id="petition_diagnosis">
                                                <option value="">Seleccione...</option>
                                                {this.state.list_diagnosis.map((l, i)=>(
                                                    <option key={i} value={l.Name}>{l.Name}</option>
                                                ))}
                                            </select>}                                    
                                        </div>
                                    :field.key === 'PROCESS_TYPE' ?
                                        <div className="col-xs-12 col-sm-2" key={i}>
                                            <span className="span-min">Tipo de Proceso</span>
                                            <select className="form-control" name="process_type" id="process_type" required={field.required}
                                                value={this.state.process_type || ""} onKeyPress={(e) => this.props.validate(e)} 
                                                onChange={this.handleChange}  disabled={this.props.state.disabledFields}>
                                                <option value="">Seleccione...</option>
                                                {this.state.petition_aferesis.map((a, i)=>{
                                                    return <option key={i} value={a.key}>
                                                        {a.name}
                                                    </option>
                                                })}
                                            </select>
                                        </div>
                                    :null
                                :null
                            )}
                        </div>
                        <div className="col-xs-12 form-group">
                            {this.state.petition === 'COMPONENTS' || this.state.petition === 'URGENT_COMPONENTS' ?
                                <div>
                                    <div className="col-xs-12 col-sm-5">
                                        <div className="col-xs-12 col-sm-7" style={{padding:'0'}}>
                                            <span className="span-min">Componente Sanguíneo</span>
                                            <select className="form-control" name="blood_component_type"
                                                id="blood_component_type" 
                                                disabled={this.props.state.disabledFields}
                                                onKeyPress={(e) => this.props.validate(e)} 
                                                value={this.state.blood_component_type || ""} 
                                                onChange={this.handleChange}>
                                                <option value="">Seleccione...</option>
                                                {this.state.blood_components.map((c, i)=>{
                                                    return <option key={i} value={c.key}>
                                                        {c.name}
                                                    </option>
                                                })}
                                            </select>
                                        </div>

                                        <div className="col-xs-12 col-sm-4" style={{paddingLeft:"16px"}}>
                                            <span className="span-min">Cantidad</span>
                                            <input type="number" className="form-control hour-input" name="blood_component_amount" 
                                                id="blood_component_amount" disabled={this.props.state.disabledFields}
                                                onKeyPress={(e) => this.props.validate(e)}
                                                value={this.state.blood_component_amount || ""} 
                                                onChange={this.handleChange} />
                                        </div>
                                        <div className="col-xs-12 col-sm-1" style={{marginTop:"20px"}}>
                                            <FloatingActionButton className="action-btn" iconStyle={{height: 25, width: 25}} mini={true} 
                                                onClick={this.addComponent} disabled={this.props.state.disabledFields} >
                                                <ContentAdd/>
                                            </FloatingActionButton> 
                                        </div>
                                    </div>																				
                                </div>
                            :this.state.petition === 'LABORATORY'?
                                <div>
                                    <div className="col-xs-12 col-sm-5">
                                        <div className="col-xs-12 col-sm-3" style={{paddingLeft:'0'}}>
                                            <span className="span-min">T. Solicitud</span>
                                            <select className="form-control" name="solicitud_type" id="solicitud_type" 
                                                value={this.state.solicitud_type} onChange={this.handleChange}
                                                disabled={this.props.state.disabledFields}>
                                                <option value="">Seleccione...</option>
                                                <option value="PRUEBA">PRUEBA</option>
                                                <option value="PERFIL">PERFIL</option>
                                            </select>
                                        </div>

                                        {this.state.solicitud_type !== 'PRUEBA' &&
                                            this.state.petition_type !== 'TRATAMIENTO CON PRODUCTOS PLASMÁTICOS' && 
                                            this.state.petition === 'LABORATORY' ?
                                            <div className="col-xs-12 col-sm-9">
                                                <span className="span-min">Seleccione Perfil</span>
                                                <Typeahead
                                                    labelKey={(option) => (`${option.profile.name}`)}
                                                    minLength={0}
                                                    options={this.state.profile_list.length > 0 ? this.state.profile_list : []}
                                                    onChange={this.onChangeTest('profile')}	
                                                    inputProps={{
                                                        name:"profile",
                                                        id:"profile"
                                                    }}
                                                    id="profile_test"
                                                    disabled={this.props.state.disabledFields || this.state.cant_change}
                                                    isLoading={this.state.isLoading}
                                                    useCache={false}
                                                    ref={ref => this._typeahead_profile = ref}
                                                    defaultSelected={this.state.profile_list.slice(this.state.index_profile, 1)}
                                                    selected={this.state.profile_selected}
                                                    delay={600}
                                                    paginationText="Mostrar mas resultados..."
                                                />
                                            </div>
                                        : this.state.solicitud_type === 'PRUEBA' && 
                                            this.state.petition === 'LABORATORY'? 
                                            <div>
                                                <div className="col-xs-12 col-sm-7">
                                                    <span className="span-min">Seleccione Prueba</span>
                                                    
                                                    <Typeahead
                                                        labelKey={(option) => (`${option.analitical_test.name}`)}
                                                        minLength={0}
                                                        options={this.state.analitical_list.length > 0 ? this.state.analitical_list : []}
                                                        onChange={this.onChangeTest('test')}	
                                                        inputProps={{
                                                            name:"test",
                                                            id:"test"
                                                        }}
                                                        id="test_text"
                                                        disabled={this.props.state.disabledFields}
                                                        isLoading={this.state.isLoading}
                                                        ref={ref => this._typeahead_test = ref}
                                                        useCache={false}
                                                        delay={600}
                                                        paginationText="Mostrar mas resultados..."
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-1" style={{marginTop:"20px"}}>

                                                    <FloatingActionButton className="action-btn"  mini={true} 
                                                        iconStyle={{height: 25, width: 25}}
                                                        disabled={this.props.state.disabledFields}
                                                        onClick={this.addTestProfile.bind(this, 'test')} >

                                                        <ContentAdd/>
                                                    </FloatingActionButton> 
                                                </div>
                                            </div>
                                        :null}

                                    </div>
                                </div>
                            :this.state.petition === 'PLASMATIC_PRODUCTS' ?
                                <div>
                                    <div className="col-xs-12 col-sm-5" style={{paddingLeft: "0px"}}>										
                                        <div>
                                            <div className="col-xs-12 col-sm-9" style={{paddingRight: "3px"}}>
                                                <span className="span-min">Producto Hemostáticos</span>
                                            
                                                <Typeahead
                                                    labelKey={(option) => (`${option.name}`)}
                                                    minLength={0}
                                                    options={this.state.plasmatic_products.length > 0 ? this.state.plasmatic_products : []}
                                                    onChange={this.handleTypeAheadChange('product')}	
                                                    inputProps={{
                                                        name:"product",
                                                        id:"product",
                                                        autoComplete:"off",
                                                    }}
                                                    disabled={this.props.state.disabledFields}
                                                    id="auto_product"
                                                    isLoading={this.state.loading_product}
                                                    useCache={false}
                                                    ref={ref => this._typeahead_product = ref}
                                                    defaultSelected={this.state.plasmatic_products.slice(this.state.index_product, 1)}
                                                    selected={this.state.product_selected}
                                                    selectHintOnEnter={true}
                                                    delay={600}
                                                    paginationText="Mostrar mas resultados..."
                                                />


                                            </div>
                                            <div className="col-xs-12 col-sm-2" style={{paddingLeft: "11px"}}>
                                                <span className="span-min">Cantidad</span>
                                                <input type="text" className="form-control" name="plasmatic_product_amount" 
                                                    id="plasmatic_product_amount"
                                                    disabled={this.props.state.disabledFields}
                                                    value={this.state.plasmatic_product_amount} onChange={this.handleChange} />
                                            </div>
                                            <div className="col-xs-12 col-sm-1" style={{marginTop:"20px"}}>
                                                <FloatingActionButton className="action-btn" iconStyle={{height: 25, width: 25}} mini={true} 
                                                    onClick={this.addPlasmatic} disabled={this.props.state.disabledFields} >
                                                    <ContentAdd/>
                                                </FloatingActionButton> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            :null}
                            {this.state.fields.map((field, i)=>
                                field.print ?
                                    field.key === 'OBSERVATIONS' ?
                                        <div 
                                            className={this.state.petition === 'COMPONENTS' || this.state.petition === 'URGENT_COMPONENTS' ||
                                                    this.state.petition === 'LABORATORY' || this.state.petition === 'PLASMATIC_PRODUCTS' ?
                                                        "col-xs-12 col-sm-7" 
                                                    : "col-xs-12 col-sm-5" }
                                            key={i}
                                        >
                                            <span className="span-min">Observaciones</span>
                                            <span style={{fontSize:'10px', marginLeft:'5px'}}>{'Caracteres restantes : '+this.state.character_observa}</span>
                                            <textarea className="form-control" name="petition_observations" id="petition_observations" required={field.required}
                                                value={this.state.petition_observations || ""} style={{resize:"none"}} disabled={this.props.state.disabledFields}
                                                onKeyPress={(e) => this.props.validate(e)} onChange={this.handleChange} style={{height:"70px",width:"100%",resize:"none"}}>
                                            </textarea>
                                        </div>
                                    :null
                                :null
                            )}
                        </div>
                        <div className="col-xs-12">
                            {this.state.petition === 'COMPONENTS' || this.state.petition === 'URGENT_COMPONENTS' ?
                                <div className="col-xs-12 col-sm-5">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th>Componente Sanguíneo</th>
                                                <th>Cantidad</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.petition_components.map((p, i)=>{
                                                return <tr key={i}>
                                                    <td>{p.component_type.replace('_', ' ')}</td>
                                                    <td>{p.amount}</td>
                                                    <td>
                                                        <button className="btn btn-info btn-xs" title="Eliminar" 
                                                            style={{marginRight:'3px'}} 
                                                            disabled={this.props.state.disabledFields}
                                                            onClick={() =>  this.removeFromList(i)}>
                                                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            :this.state.petition === 'LABORATORY' ?
                                <div className="col-xs-12 col-sm-5">
                                    <Table>
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Pruebas Asignadas</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.list_test.map((list, i)=>{
                                                return <tr key={i}>
                                                    <td>
                                                        <input type="checkbox" id={"test_"+list.id} checked={list.check} 
                                                            onChange={this.checked} disabled={this.props.state.disabledFields}/>
                                                    </td>
                                                    <td>{list.name}</td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </Table>
                                </div>
                            
                            :this.state.petition === 'PLASMATIC_PRODUCTS' ?
                                <div className="col-xs-12 col-sm-5">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th>Producto Hemostáticos</th>
                                                <th>Cantidad</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.plasmaticAdded.map((p, i)=>(
                                                <tr key={i}>
                                                    <td>{p.name}</td>
                                                    <td>{p.amount}</td>
                                                    <td>
                                                        <button className="btn btn-info btn-xs" title="Eliminar" 
                                                            style={{marginRight:'3px'}} 
                                                            disabled={this.props.state.disabledFields}
                                                            onClick={() =>  this.removePlasmatic(i)}>
                                                            <SvgIcon icon={bin} style={{paddingTop:"3px"}}/>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            :null}	
                            <div className="col-xs-12 col-sm-5">
                                <div className="col-xs-12 col-sm-8" style={{marginTop:'10px'}}>
                                    {this.state.fields.map((field, i)=>
                                        field.print ?
                                            field.key === 'POLITRANSFUSED' ?
                                                this.state.pat_pol_trans === 'YES' && this.state.petition !== 'APHERESIS'?
                                                    <div key={i}>
                                                        <input type="checkbox" name="politransfused" id="politransfused"
                                                            onChange={this.handleChange} required={field.required}
                                                            checked={this.state.politransfused} 
                                                            disabled={this.props.state.disabledFields}
                                                            style={{marginRight:"5px"}}/>
                                                        <span className="span-min">Politransfundido</span>
                                                    </div>
                                                :null
                                            :field.key === 'PREVIAL_TRANSFUTION' ?
                                                <div key={i}>
                                                    <span className="span-min">Transfusiones Previas</span>
                                                    <select name="petition_previal_transfution" id="petition_previal_transfution" className="form-control"
                                                        value={this.state.petition_previal_transfution} required={field.required}
                                                        onChange={this.handleChange} disabled={this.props.state.disableFields}
                                                    >
                                                        <option value="">Seleccione...</option>
                                                        <option value="SI, HACE MAS DE 3 MESES">SI, HACE MAS DE 3 MESES</option>
                                                        <option value="SI, EN LOS ÚLTIMOS 3 MESES">SI, EN LOS ÚLTIMOS 3 MESES</option>
                                                        <option value="NO">NO</option>
                                                    </select>
                                                </div>
                                            :field.key === 'CONSENTIMIENTO_INFORMADO' ?
                                                <div key={i}>
                                                    <input type="checkbox" name="petition_consentimiento" id="petition_consentimiento" required={field.required}
                                                        style={{marginRight:"5px"}} onChange={this.handleChange} disabled={this.props.state.disabledFields}/>
                                                    <span className="span-min">Consentimiento Informado</span>
                                                </div>                                    
                                            :null
                                        :null
                                    )}
                                </div>
                            </div>                    
                        </div>
                    </fieldset>

					<div className="col-xs-12">
						{this.state.list_components.length > 0 ?
							<Table responsive hover>
								<thead>
									<tr>
										<th>Componente</th>
										<th>Unidad Reservada</th>
										<th>Fecha Reserva</th>
										<th></th>
										<th>Unidad Enviada</th>
										<th>Fecha Envío</th>
										<th></th>
										<th>Unidad Devuelta</th>
										<th>Fecha Devolución</th>
										<th>Destino</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{this.state.list_components.map((list, i)=>(
										<tr key={i}>
											<td>{list.component}</td>
											<td>{list.unit_reserved_number}</td>
											<td>{list.reserved_date !== null ? moment(list.reserved_date).format('DD/MM/YYYY') : ""}</td>
											<td>
												{this.props.task_unit_reserves.delete ?
													list.unit_delivered_id === null && list.reserved_id !== null?
														<button className="btn btn-info" 
															onClick={(e)=>this.deleteProcess(e, list, 'Reserva')}	>
															<SvgIcon size={15} icon={bin} />
														</button>
													:null
												:null}												
											</td>
											<td>{list.unit_delivered_number}</td>
											<td>{list.delivered_date !== null ? moment(list.delivered_date).format('DD/MM/YYYY HH:mm') : ""}</td>
											<td>
												{this.props.task_unit_delivered.delete ? 
													list.unit_delivered_id !== null && list.returns_id === null?
														<button className="btn btn-info"
															onClick={(e)=>this.deleteProcess(e, list, 'Envío')}	>
															<SvgIcon size={15} icon={bin} />
														</button>
													:null
												:null}												
											</td>
											<td>{list.unit_return_number}</td>
											<td>{list.return_date !== null ? moment(list.return_date).format('DD/MM/YYYY HH:mm') : ""}</td>
											<td>{list.destiny}</td>
											<td>
												{list.returns_id !== null ? 
													this.props.task_has_user_profiles.map((t)=>(
														t === 'CANCEL_RETURNS_DELIVERY' ? 
															<button className="btn btn-info" 
																onClick={(e)=>this.deleteProcess(e, list, 'Devolución')}	>
																<SvgIcon size={15} icon={bin} />
															</button>
														:null
													))															
												:null}												
											</td>
										</tr>
									))}
								</tbody>
							</Table>
						:null}
					</div>

					<div className="col-xs-12 form-group" style={{marginTop:'10px', textAlign:'center'}}>
						{this.state.petition === "COMPONENTS" ||
						this.state.petition === 'LABORATORY' ?
							<button className="toolIcon" disabled={
								this.state.have_samples ? false : this.props.match.params.id === undefined}
								onClick={this.newSample} >
								<SvgIcon size={40} icon={clipboard} 
									style={this.state.flag_samples === 'NO_SAMPLES' ?
											{color:'#a39f9f'}
										: this.state.flag_samples === 'WITH_SAMPLES' ?
											{color:'rgb(var(--primary))'}
										: {color:'#a39f9f'}
									}
									
									/>
								<div className="col-xs-12">
									<span>Muestras</span>
								</div>
							</button>
						: null}
							
						<button className="toolIcon" disabled={this.props.match.params.id === undefined} 
							onClick={(e)=>this.printConcent(e, this.props.match.params.id)}	>
							<SvgIcon size={40} icon={print} />
							<div className="col-xs-12">
								<span>{t('toolbar.print_con')}</span>
							</div>
						</button>

						{(this.state.petition === 'APHERESIS' && this.state.show_details) &&
							<button className="toolIcon" disabled={this.props.match.params.id === undefined} 
								onClick={(e)=>{e.preventDefault(); return this.props.history.push('/apheresis_details/'+this.state.petition_id)}}	>
								<SvgIcon size={40} icon={notepad_add} />
								<div className="col-xs-12">
									<span>Detalles</span>
								</div>
							</button>
						}

						{this.state.petition === 'PLASMATIC_PRODUCTS' &&
							<button className="toolIcon" disabled={this.props.match.params.id === undefined} 
								onClick={(e)=>{e.preventDefault(); return this.props.history.push('/plasmatic_products/despatch/'+this.state.petition_id)}}	>
								<SvgIcon size={40} icon={upload2} />
								<div className="col-xs-12">
									<span>Envio</span>
								</div>
							</button>
						}

						{this.state.petition === 'URGENT_COMPONENTS' &&
							<button className="toolIcon" disabled={this.props.match.params.id === undefined} 
								onClick={(e)=>{e.preventDefault(); return this.props.history.push('/petition_register/unitSend/'+this.state.petition_id)}}	>
								<SvgIcon size={40} icon={upload2} />
								<div className="col-xs-12">
									<span>Envio</span>
								</div>
							</button>
						}

						{this.state.pat_pet_cond === 'YES' &&
							<button className="toolIcon" disabled={this.props.match.params.id === undefined} 
								onClick={(e)=>this.openConditions(e)} 
								style={this.state.flag_condition ?  {color:'rgb(var(--primary))'} : {color: '#333333'}}>
								<SvgIcon size={40} icon={heartbeat} />
								<div className="col-xs-12">
									<span>Condiciones</span>
								</div>
							</button>
						}
							

						
						{this.state.pet_fam_res.value === 'YES' ?
							<button className="toolIcon" 
								onClick={this.openFamiliar}	>
								<SvgIcon size={40} icon={user} />
								<div className="col-xs-12">
									<span>Familiar Responsable</span>
								</div>
							</button>
						: null}
						

						<button className="toolIcon" disabled={this.props.match.params.id === undefined} 
							onClick={(e)=>this.printCard(e, this.props.match.params.id)}	>
							<SvgIcon size={40} icon={print} />
							<div className="col-xs-12">
								<span>Ficha del Paciente</span>
							</div>
						</button>

						<button className="toolIcon" disabled={this.props.match.params.id === undefined} 
							onClick={(e)=>this.printLetter(e, this.props.match.params.id)}	>
							<SvgIcon size={40} icon={print} />
							<div className="col-xs-12">
								<span>Carta Compromiso</span>
							</div>
						</button>
					</div>

					<div className="col-xs-12" style={{textAlign:'center'}}>
						<RaisedButton className="action-btn" label={t('content.generics.buttons.save')} primary style={{margin:12}}
							disabled={this.props.disabledFields}
							onClick={()=>this.props.onSave()}
						/>
						<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} 
		        			 style={{margin:12}} onClick={()=>this.props.regresar()} />
					</div>
				</div>


				<div className="col-xs-3" style={{background:'#f2f4f6'}}>
					{this.state.rai !== "" &&
						<div className="col-xs-12 col-sm-5">
							<span className="span-min" style={{fontSize:'1em'}}>RAI: </span>
							<span style={{fontSize:'1.5em', marginLeft:'5px', color:'red'}}>{this.state.rai}</span>
						</div>
					}
					{this.state.rai !== "" &&
						<div className="col-xs-12 col-sm-7" style={{marginTop:7}}>
							<span className="span-min" style={{fontSize:'1em'}}>Fecha RAI: </span>
							<span style={{fontSize:'0.8em', marginLeft:'5px'}}>{this.state.rai_date}</span>
						</div>
					}
					<div className="col-xs-12">
	                	<h1 style={{color:'red', textAlign:'center', fontSize:'5em'}}>
	                        {this.state.lookup_group}
	                        {this.state.lookup_rh === 'POSITIVO' ? '+':
	                        this.state.lookup_rh === 'NEGATIVO'     ? '-':''}
	                   	</h1>
                   	</div>

                   	{this.state.lectina !== "" && this.state.lectina !== 'NO PROCESADO' ? 
                    	<div className="col-xs-12 col-sm-6">
                    		<span className="span-min" style={{fontSize:'1.5em'}}>Lectina: </span>
	                    	<span style={{fontSize:'1em', marginLeft:'5px'}}>{this.state.lectina}</span>
                        </div>
                   	: null }
                   	{this.state.du !== "" ? 
                   		<div className="col-xs-12 col-sm-6">
                   			<span className="span-min" style={{fontSize:'1.5em'}}>DU: </span>
                   			<span style={{fontSize:'1em', marginLeft:'5px'}}>{'('+this.state.du+')'}</span>
	                    </div>
                   	: null }

                   	{this.state.phenotypes !== "" ?
                   		<div className="col-xs-12 form-group">
                   			<span className="span-min" style={{fontSize:'1.5em'}}>Fenotipos: </span>
                   			<span style={{fontSize:'1em', display:'block' }}>{'('+this.state.phenotypes+')'}</span>
	                    </div>
                   	:null}
                   	{this.state.antibodys !== "" ?
                   		<div className="col-xs-12 form-group">
                   			<span className="span-min" style={{fontSize:'1.5em'}}>Anticuerpos: </span>
                   			<span style={{fontSize:'1em', display:'block' }}>{'('+this.state.antibodys+')'}</span>
	                    </div>
                   	:null}

                   	{this.state.list_unit_reserved.length > 0 ?
                   		<fieldset className="col-xs-12 form-group">
	                   		<legend>Unidades Reservadas</legend>
	                   		<Table hover>
	                   			<thead>
	                   				<tr>
	                   					<th>Componente</th>
	                   					<th>Cantidad</th>
	                   				</tr>
	                   			</thead>
	                   			<tbody>
	                   				{this.state.list_unit_reserved.map((u, i)=>(
	                   					<tr key={i}>
	                   						<td>{u.component}</td>
	                   						<td>{u.amount}</td>
	                   					</tr>
	                   				))}
	                   			</tbody>
	                   		</Table>
	                   	</fieldset>
                   	:null}

                   	{this.state.list_unit_delivered.length > 0 ?
                   		<fieldset className="col-xs-12 form-group">
	                   		<legend>Unidades Enviadas</legend>
	                   		<Table hover>
	                   			<thead>
	                   				<tr>
	                   					<th>Componente</th>
	                   					<th>Cantidad</th>
	                   				</tr>
	                   			</thead>
	                   			<tbody>
	                   				{this.state.list_unit_delivered.map((u, i)=>(
	                   					<tr key={i}>
	                   						<td>{u.component}</td>
	                   						<td>{u.amount}</td>
	                   					</tr>
	                   				))}
	                   			</tbody>
	                   		</Table>
	                   	</fieldset>
                   	:null}

                   	{this.state.last_date_send !== "" ?
                   		<div className="col-xs-12 form-group">
                   			<span className="span-min" style={{fontSize:'1.5em'}}>Fecha de último envío: </span>
                   			<span style={{fontSize:'1em', marginLeft:'5px' }}>{'('+this.state.last_date_send+')'}</span>
	                    </div>
                   	:null}

	                {this.state.petition_history.length > 0 ?
                   		<fieldset className="col-xs-12 form-group">
	                   		<legend>Últimas solicitudes</legend>
	                   		<Table hover className="fixed_header">
	                   			<thead>
	                   				<tr>
	                   					<th style={!this.props.state.disabledFields ? {width:'27%'} : {width:'31%'}}>Tipo</th>
	                   					<th style={!this.props.state.disabledFields ? {width:'14%'} : {width:'14%'}}>Fecha</th>
	                   					<th hidden={this.props.state.disabledFields} style={{width:'5%'}}></th>
	                   				</tr>
	                   			</thead>
	                   			<tbody>
	                   				{this.state.petition_history.map((u, i)=>(
	                   					<tr key={i}>
	                   						<td>{u.name}</td>
	                   						<td>
	                   							{moment(u.full_date).format('DD/MM/YYYY HH:mm')}
	                   						</td>
	                   						<td hidden={this.props.state.disabledFields}>
	                   							<a href="" >
	                   								<SvgIcon size={25} icon={minusSquareO} size={25} 
														title="Petición" onClick={(e)=>this.samples(e, u.id)}/>
	                   							</a>
	                   						</td>
	                   					</tr>
	                   				))}
	                   			</tbody>
	                   		</Table>
	                   	</fieldset>
                   	:null}

				</div>

				<ModalFamiliar {...this.props} onRef={ref => this.modal_familiar = ref} setFamiliar={this.setFamiliar} />
				<ModalSamples {...this.props} 
					handleChange={this.handleChange}
					getList={this.getList} 
					onRef={ref => (this.modal_samples = ref)} />
				<ModalNotes {...this.props} onRef={ref => (this.modal_notes = ref)} patient={this.state.patient_id} />
				<ModalPersonSearch {...this.props} 
					waiting={this.props.waiting} 
					updatePerson={this.getInfo} 
					onRef={ref => (this.modal_person_search = ref)} 
					search={this.getInfo}
					persons={this.state.patient_list}
				/>
				<ModalInfo {...this.props} onRef={ref => (this.modal_info = ref)} />
				<ModalCenter {...this.props} onRef={ref => (this.modal_add_center = ref)} 
					refresh={this.getHealthFacilities} />

				<ModalConditions {...this.props} onRef={ref => this.modal_conditions = ref} />

				<SearchImss {...this.props} onRef={ref => this.search_imss = ref} updateState={this.getInfo} />
				<SearchSearchIsste {...this.props} onRef={ref => this.isste_search = ref} updateState={this.getInfo} />
									

			</div>
		)
	}
}

export default translate('translations')(PetitionForm);